import "./SettingIndex.css"
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    Button,
    Dropdown,
    Modal,
    notification,
    Space,
    Switch,
    message,
    ConfigProvider,
    Spin,
    Checkbox,
    Tooltip, Select
} from "antd";
import {getSysConfig, updateSysConfig} from "@model/sysconfig";
import emitter, {
    ACCESS_TOKEN,
    arrayCardDisplayModeMenu,
    arrayConnectorTypeMenu,
    arrayDarkMenu, arrayDefaultNoCookie, arrayDefaultSearchEngine, arrayDefaultWebviewerOpen,
    arrayDoubleClickMenu,
    arrayLanguages,
    arrayOnOff,
    arrayVisiblityMenu, DB_AUTO_BACKUP_TIME,
    DEFAULT_HOME_LEFT_MENU,
    DEFAULT_SHORTCUTS_CONFIG,
    EVENT_AUTO_UPDATE_IS_READY,
    EVENT_CHANGE_THEME,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_FORCE_UPDATE,
    EVENT_LANGUAGE_CHANGED,
    EVENT_NOTE_CHANGED,
    EVENT_REFRESH_HOME_LEFT_MENU,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_LOGIN_STATUS,
    EVENT_REFRESH_USER_IFNO,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    EVENT_SHOW_SNAP_LINE,
    EVENT_TOGGLE_THEME, FROM_LINK_TO_PROJECT,
    GET_ARRAY_SHORTCUTS, GET_DEFAULT_WEBVIEWER_CONFIG,
    IMPORT_FILE_MODE_ASKME,
    IMPORT_FILE_MODE_IMPORTMODE,
    IMPORT_FILE_MODE_LINKMODE, KEY_AUTO_BACKUP_INTERVAL,
    KEY_AUTO_BACKUP_PATH,
    KEY_AUTO_SAVE_CLOUD_DB,
    KEY_BACKUP_PATH,
    KEY_ENABLE_AUTO_BACKUP,
    KEY_FILE_DIR,
    KEY_FILE_IMPORT_MODE,
    KEY_FILE_SIZE_LARGER_THEN_MODE,
    KEY_FILE_SIZE_SMALLER_THEN_MODE,
    KEY_FILE_SIZE_SPLIT,
    KEY_GLOBAL_CARD_DISPLAY_MODE,
    KEY_GLOBAL_CONNECTOR_TYPE,
    KEY_GLOBAL_DOUBLE_CLICK_ELEMENT,
    KEY_GLOBAL_INFO_VISIBLE,
    KEY_GLOBAL_SHORTCUTS_CONFIG,
    KEY_GLOBAL_SNAP_LINE_VISIBLE,
    KEY_GLOBAL_SPELLCHECKER,
    KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP,
    KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP,
    KEY_GLOBAL_YOUTUBE_EMBED_MODE,
    KEY_HAS_DEFAULT_HOME,
    KEY_HOME_LEFT_MENU_CUSTOMIZE,
    KEY_IS_ENABLE_SYNC,
    KEY_LAST_SYNC_TIME, KEY_QUICKNOTE_CONFIG,
    KEY_USER_INFO, KEY_WEBVIEWER_CONFIG,
    LOGIN_ACCOUNT,
    SYS_CONFIG_DEV_MODE,
    SYS_CONFIG_FREE_CARD_MODE,
    SYS_CONFIG_KEY_AUTOUPDATE,
    SYS_CONFIG_KEY_DATEFORMAT,
    SYS_CONFIG_KEY_LANGUAGE_CODE,
    SYS_CONFIG_KEY_THEME,
    THEME_DARK
} from "@/Const";
import {
    checkTimeZone,
    extFromMineType,
    formatDate,
    generateUUID2,
    getCookies,
    getCtrlOrAltCmd,
    getFileName,
    getImageFileNameListFromDoc,
    getImagePath,
    getImagePathWithTheme, getImagePathWithThemeSvg,
    getTimezone,
    hasDesktopBaseLicense,
    hasLicense,
    hasPublishLicense,
    imgPathPerfix,
    isDarkMode,
    isEmptyStringObject,
    isInDraw, isInJournal, isInPageCardOrJournal, isInPageHighlight, isInPageLibrary, isInPageProperties, isInPageTag,
    isNumber,
    isStringNullOrEmpty
} from "@/utils";
import LoginIndex from "@/views/Home/views/Login/LoginIndex";
import {ipcInvoke, ipcOn, ipcOnce, ipcRemove, ipcRemoveThisAll, ipcSend} from "@/common/ipc";
import * as process from "process";
import {getUserInfo} from "@/api/Api";
import Global from "@/global";
import {postMessage, recvMessage} from "@/common/event";
import {useTranslation} from "react-i18next";
import {isZh, switchLanguage} from "@/language";
import {IconClose, IconDropdown, IconDropdownTriangle, IconDropdownTriangleNoMargin, IconIndicatorWhite} from "@/Icon";
import DialogUpdate from "@/views/Home/views/Setting/DialogUpdate";
import {APP_WEB_WWW, DEBUG, isWeb} from "@/electron_interactive";
import {switchBaseURL} from "@/api/request";
// import cookie from 'react-cookies'
import style from '../../../../part.module.less'
import global from "@/global";
import DialogMessageBox from "@/common/DialogMessageBox";
import {syncS3} from "@/api/Sync";
import {LoadingOutlined} from "@ant-design/icons";
import {exportDb, importDb, restoreDbNoClear} from "@model/init";
import {getAllCardList, getCardDoc, getCardList} from "@model/card";
import {imgServer} from "@/components/Editor/imgServer";
import {t} from "i18next";
import {getNoteDoc, getNoteList, getProjectById} from "@model/note";
import {isAutoEnableSync, isInSingleFloatWindow, isMac} from "@/Utility";
import {useAtom} from "jotai";
import { atomHomeLeftMenu} from "@/views/Home/HomeIndex";
import {clearProjectHistoryDoc} from "@model/projectHistory";
import DialogLicenseHelper from "@/views/Dialog/DialogLicenseHelper";
import DialogOtherTip from "@/views/Dialog/DialogOtherTip";
import {loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {
    isProjectLinkElement,
    isStickyNotesElement,
    isTextElement
} from "../../../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {KEYS} from "../../../../../@excalidraw/packages/excalidraw/keys";
import {sub} from "../../../../../@excalidraw/packages/excalidraw/ga";
import {initDefaultProperty} from "@model/Property";
import {getBoardList} from "@model/board";
import {getTiptapDoc} from "@model/tiptapDoc";
import {getTagList} from "@model/tag";

let isReigster = false;
let mFirstClickTime=0;
let mClickTimes=0;
let mIsQuering = false;
let mMouseDownloadTime = 0;
let mIsDownPressed = false;
let mszBackupPath = '';
let mszAutoBackupPath = '';
let mIsRestoreDbComplete = false,mIsRestoreFileComplete = false;
let mIsShowBackupSuccess = false;
let mBackupMode:any = '';//'full' | 'onlyDb' | '';
let mRestoreFileProgress = 0,mRestoreDbDataProgress = 0;
const SettingIndex = forwardRef(function (props:{}, ref) {
    useImperativeHandle(ref,()=>({
        onDialogShow:onDialogShow,
        onShowLogin:onShowLogin
    }));


    const {t} = useTranslation();
    const [currentVersion,setCurrentVersion] = useState('V1.0.0');
    const [updateInfo,setUpdateInfo] = useState(t("You used latest version"));
    const [isAutoUpdate,setIsAutoUpdate] = useState(false);
    const [isEnableSync,setIsEnableSync] = useState(false);
    const [isEnableAutoBackup,setIsEnableAutoBackup] = useState(false);
    const [themeName,setThemeName] = useState(t("Light"));
    const [dateFormat,setDateFormat] = useState("dd/MM/yyyy");
    const [languageName,setLanguageName]=useState("English");
    const [isLoginDialogShow,setIsLoginDialogShow] = useState(false);
    const [isLoginSuccess,setIsLoginSuccess] = useState(false);
    const [loginAccountDesc,setLoginAccountDesc] = useState(t("No login no publish"));
    const [isCheckingUpdate,setIsCheckingUpdate] = useState(false);
    const [isComLicLoading,setIsComLicLoading] = useState(false);
    const [isPubLicLoading,setIsPubLicLoading] = useState(false);
    const [updateProgress,setUpdateProgress] = useState(t("Check update"))
    const [licenseInfoDesc,setLicenseInfoDesc] = useState(t("Please login first"));
    const [hasCommunity,setHasCommunity] = useState(true);
    const [isShowSettingDialog,setIsShowSettingDialog] = useState(false);
    const [isDevMode,setIsDevMode] = useState(false);
    const [syncInfo,setSyncInfo] = useState('');
    const [isSyncing,setIsSyncing] = useState(false);
    const [sync,setSync] = useState(t('Sync'));
    const [currentMenu,setCurrentMenu] = useState('general');
    const [backupPath,setBackupPath] = useState(localStorage.getItem(KEY_BACKUP_PATH)??'');
    const [autoBackupPath,setAutoBackupPath] = useState(localStorage.getItem(KEY_AUTO_BACKUP_PATH)??'');
    const [backupProgress,setBackupProgress] = useState(0);
    const [restoreProgress,setRestoreProgress] = useState(0);
    const [isBackuping,setIsBackuping] = useState(false);
    const [isAutoBackuping,setIsAutoBackuping] = useState(false);
    const [isRestoring,setIsRestoring] = useState(false);
    const [isShowBackupFinishedView,setIsShowBackupFinishedView] = useState(false);
    const [isShowAutoBackupFinishedView,setIsShowAutoBackupFinishedView] = useState(false);
    const [fileDir,setFileDir] = useState('')
    const [isAdvancedChecked,setIsAdvanceChecked] = useState(false);
    const [importFileMode,setImportFileMode] = useState(localStorage.getItem(KEY_FILE_IMPORT_MODE) || 'importMode');
    const [fileSizeSplitPlaceholder,setFileSizeSplitPlaceholder] = useState(localStorage.getItem(KEY_FILE_SIZE_SPLIT) || '50')
    const [fileSizeSplit,setFileSizeSplit] = useState('')
    const [fileSizeSmallerThenMode,setFileSizeSmallerThenMode] = useState(localStorage.getItem(KEY_FILE_SIZE_SMALLER_THEN_MODE) || 'importMode')
    const [fileSizeLargerThenMode,setFileSizeLargerThenMode] = useState(localStorage.getItem(KEY_FILE_SIZE_LARGER_THEN_MODE) || 'linkMode')
    const [autoBackupInterval,setAutoBackupInterval] = useState(localStorage.getItem(KEY_AUTO_BACKUP_INTERVAL) || (DB_AUTO_BACKUP_TIME+''))

    const [webviewerConfig,setWebviewerConfig] = useState({});
    const [quickNoteDefaultConfig,setQuickNoteDefaultConfig] = useState({});
    const [defaultQuickNoteProjectName,setDefaultQuickNoteProjectName] = useState('');

    const dialogUpdateRef = useRef(null);
    const dialogMessageBoxRef = useRef(null);
    const dialogLicenseHelperRef = useRef(null);
    const dialogOtherTipRef = useRef(null);
    //用户信息
    const [userInfo,setUserInfo] = useState<any>(Global.g_userInfo);
    const [visibleInfoPanel,setVisibleInfoPanel] = useState('');
    const [doubleClickElement,setDoubleClickElement] = useState('');
    const [visibleSnapLine,setVisibleSnapLine] = useState('');
    const [connectorType,setConnectorType] = useState('');
    const [cardDisplayMode,setCardDisplayMode] = useState('');
    const [spellChecker,setSpellChecker] = useState('');
    const [youtubeEmbedMode,setYoutubeEmbedMode] = useState('')
    const [randomKey,setRandomKey] = useState(generateUUID2());
    // const [arrayThemeOptions,setArrayThemeOptions] = useState(arrayDarkMenu());

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    //快捷键配置
    const [shortcutsConfig,setShortcutsConfig] = useState(DEFAULT_SHORTCUTS_CONFIG);

    //同步全局的配置
    const [cloudSyncPreferences,setCloudSyncPreferences] = useState({autoRefreshWhenOpenApp:false,autoSyncWhenCloseApp:false})

    const mGlobalPreference = useRef<any>({});

    const FILE_IMPORT_MODE = [
        {
            value:IMPORT_FILE_MODE_IMPORTMODE,label:t('Import mode')
        },
        {
            value:IMPORT_FILE_MODE_LINKMODE,label:t('Link mode')
        },
        {
            value:IMPORT_FILE_MODE_ASKME,label:t('Asked each time')
        }
    ]

    const [arrayFileSmallerThen,setArrayFileSmallerThen] = useState(FILE_IMPORT_MODE);
    const [arrayFileLargerThen,setArrayFileLargerThen] = useState(FILE_IMPORT_MODE);

    const [homeLeftMenu,setHomeLeftMenu] = useState(DEFAULT_HOME_LEFT_MENU);
    const [aatomomeLeftMenu,setAAtomHomeLeftMenu] = useAtom(atomHomeLeftMenu);

    const dateNow = new Date();
    const arrayDateformats = [
        {
            key:'MM/dd/yyyy',
            label:formatDate(dateNow,"MM/dd/yyyy")
        },
        {
            key:'dd/MM/yyyy',
            label:formatDate(dateNow,"dd/MM/yyyy")
        },
        {
            key:'yyyy-MM-dd',
            label:formatDate(dateNow,"yyyy-MM-dd")
        },
        {
            key:'dd-MM-yyyy',
            label:formatDate(dateNow,"dd-MM-yyyy")
        },
        {
            key:'MM-dd-yyyy',
            label:formatDate(dateNow,"MM-dd-yyyy")
        }
    ]

    const getArrayAutoBackupOptions = ()=>{
        const arrayAutoBackupInterval = [
            {
                value:`${3*3600*1000}`,
                label:t('Every3hours')
            },
            {
                value:`${6*3600*1000}`,
                label:t('Every6hours')
            },
            {
                value:`${12*3600*1000}`,
                label:t('Every12hours')
            },
            {
                value:`${24*3600*1000}`,
                label:t('EveryDaily')
            },
            {
                value:`${7*24*3600*1000}`,
                label:t('EveryWeekly')
            }
        ]

        return arrayAutoBackupInterval;
    }


    const [messageApi,contextHolder] = message.useMessage();

    const updateProgressMessage = (event,args)=>{
        if(args.hasOwnProperty("action")){
            if(args.action === ("update-not-available")){
                setIsCheckingUpdate(false)
                setUpdateInfo(t("You used latest version"));
                messageApi.info(t("Current is latest version"));
            }else if(args.action ===("update-available")){
                setIsCheckingUpdate(false)
                setUpdateInfo(t("CurrentIsNotNewVersion"));
                Modal.destroyAll();
                // postMessage(EVENT_AUTO_UPDATE_IS_READY,{args.obj});
                /*
                Modal.confirm({
                    content:t('Checked new version'),
                    onOk(){
                        setIsCheckingUpdate(true);
                        setUpdateProgress(t('Start download'));
                        ipcSend('start-download-update')
                    },
                    onCancel(...args) {
                        setIsCheckingUpdate(false);
                    },
                })
                 */
                dialogUpdateRef.current?.onShowDialog();
            }else if(args.action ===("check-update-fail")){
                setIsCheckingUpdate(false)
                messageApi.error(t("Check update fail"));
            }else if(args.action ===("download-progress")){
                var obj = args.obj;
                setIsCheckingUpdate(true)
                setUpdateProgress(t('Downloading')+" "+obj.percent.toFixed(1) + '%')
            }else if (args.action ===("update-downloaded")){
                if (isShowSettingDialog){
                    setIsCheckingUpdate(false);
                    setUpdateProgress(t("Download finished"));
                    Modal.confirm({
                        centered:true,
                        maskClosable:false,
                        cancelText:t("Cancel"),
                        okText:t("Install"),
                        content:t("Download finished start install"),
                        onOk(...args) {
                            ipcSend('start-install')
                        },
                    })
                }else{

                }

                //本窗口没显示...
                postMessage(EVENT_AUTO_UPDATE_IS_READY,args.obj);
            }
        }
    }

    // const onShowDialog = ()=>{}

    //显示对话框
    const onDialogShow = (selectMenu:any | 'general' |'backup' | 'importFile')=>{
        setIsShowSettingDialog(true)
        setIsSyncing(false);
        refreshLastSyncTime();
        setSync(t("Sync"));
        setIsRestoring(false);
        setIsBackuping(false);
        setUpdateInfo(t("You used latest version"));
        // setArrayThemeOptions(setArrayThemeOptions());

        global.g_showDialogs['settingIndex'] = true;

        if (selectMenu){
            setCurrentMenu(selectMenu)
        }
        mIsRestoreFileComplete = mIsRestoreDbComplete = false;
        let szToken = localStorage.getItem(ACCESS_TOKEN);
        if (APP_WEB_WWW && isStringNullOrEmpty(szToken)){
            szToken = getCookies()['token'];
        }

        setFileDir(localStorage.getItem(KEY_FILE_DIR)??'')
        if (!isStringNullOrEmpty(szToken)){
            queryUserInfo();
        }

        const szLeftMenu = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);
        if (szLeftMenu){
            const jsonMenu = JSON.parse(szLeftMenu);
            if (jsonMenu.properties == undefined){
                jsonMenu.properties = true;
            }
            setHomeLeftMenu(jsonMenu);
        }

        let szDoubleClick = localStorage.getItem(KEY_GLOBAL_DOUBLE_CLICK_ELEMENT) || 'card'
        mGlobalPreference.current.KEY_GLOBAL_DOUBLE_CLICK_ELEMENT = szDoubleClick;
        let doubleClick:any = arrayDoubleClickMenu().find(p=>p.key == szDoubleClick);
        setDoubleClickElement(doubleClick?.label);

        let szVisible = localStorage.getItem(KEY_GLOBAL_INFO_VISIBLE) || 'visible';
        mGlobalPreference.current.KEY_GLOBAL_INFO_VISIBLE = szVisible;
        let visibleItem:any = arrayVisiblityMenu().find(p=>p.key == szVisible);
        setVisibleInfoPanel(visibleItem?.label);

        szVisible = localStorage.getItem(KEY_GLOBAL_SNAP_LINE_VISIBLE) || 'visible';
        mGlobalPreference.current.KEY_GLOBAL_SNAP_LINE_VISIBLE = szVisible;
        visibleItem = arrayVisiblityMenu().find(p=>p.key == szVisible);
        setVisibleSnapLine(visibleItem?.label);

        let szCurve = localStorage.getItem(KEY_GLOBAL_CONNECTOR_TYPE) || 'curve';
        mGlobalPreference.current.KEY_GLOBAL_CONNECTOR_TYPE = szCurve;
        let curveItem = arrayConnectorTypeMenu().find(p=>p.key == szCurve);
        setConnectorType(curveItem?.label);

        let szCardDisplay = localStorage.getItem(KEY_GLOBAL_CARD_DISPLAY_MODE) || 'sidePanel';
        mGlobalPreference.current.KEY_GLOBAL_CARD_DISPLAY_MODE = szCardDisplay;
        let cardDisplayItem = arrayCardDisplayModeMenu().find(p=>p.key == szCardDisplay);
        setCardDisplayMode(cardDisplayItem?.label);

        let szSpellChecker = localStorage.getItem(KEY_GLOBAL_SPELLCHECKER) || 'on';
        mGlobalPreference.current.KEY_GLOBAL_SPELLCHECKER = szSpellChecker;
        let spellChecker = arrayOnOff().find(p=>p.key == szSpellChecker);
        setSpellChecker(spellChecker?.label);

        let szYoutubeEmbedMode = localStorage.getItem(KEY_GLOBAL_YOUTUBE_EMBED_MODE);
        if (Global.g_isFirstRun){
            if (!szYoutubeEmbedMode){
                szYoutubeEmbedMode = 'noCookie';
                localStorage.setItem(KEY_GLOBAL_YOUTUBE_EMBED_MODE,szYoutubeEmbedMode);
            }
        }else{
            if (!szYoutubeEmbedMode){
                szYoutubeEmbedMode = 'default';
            }
        }
        mGlobalPreference.current.KEY_GLOBAL_YOUTUBE_EMBED_MODE = szYoutubeEmbedMode;
        let youtube = arrayDefaultNoCookie().find(p=>p.key == szYoutubeEmbedMode);
        setYoutubeEmbedMode(youtube?.label)


        let szAutoRefreshWhenOpen = localStorage.getItem(KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP)  || 'false';
        let szAutoSync = localStorage.getItem(KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP)  || 'false';
        setCloudSyncPreferences({
            autoRefreshWhenOpenApp: szAutoRefreshWhenOpen == 'true',
            autoSyncWhenCloseApp: szAutoSync == 'true'
        })

        //读取快捷键配置
        let szShortcuts = localStorage.getItem(KEY_GLOBAL_SHORTCUTS_CONFIG);
        if (szShortcuts){
            setShortcutsConfig(JSON.parse(szShortcuts));
        }else{
            setShortcutsConfig(DEFAULT_SHORTCUTS_CONFIG);
        }

        //读取webviewer配置
        let szWebviewConfig = localStorage.getItem(KEY_WEBVIEWER_CONFIG);
        if (szWebviewConfig){
            setWebviewerConfig(JSON.parse(szWebviewConfig));
        }else{
            setWebviewerConfig(GET_DEFAULT_WEBVIEWER_CONFIG())
        }

        //读取quicknotes
        let szQuickNotesConfig = localStorage.getItem(KEY_QUICKNOTE_CONFIG);
        if (szQuickNotesConfig){
            const jsonQuickNotesConfig = JSON.parse(szQuickNotesConfig);
            //判断tag是否存在..
            const arrayNewTags:any = [];
            if(jsonQuickNotesConfig.defaultTags){
                getTagList().then(res=>{
                    for (let i=0;i<jsonQuickNotesConfig.defaultTags.length;i++){
                        if (res.find(p=>p.name == jsonQuickNotesConfig.defaultTags[i])){
                            arrayNewTags.push(jsonQuickNotesConfig.defaultTags[i]);
                        }
                    }

                    if (arrayNewTags.length == 0){
                        delete jsonQuickNotesConfig.defaultTags
                    }else{
                        jsonQuickNotesConfig.defaultTags = arrayNewTags;
                    }
                    localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(jsonQuickNotesConfig));

                    setQuickNoteDefaultConfig(jsonQuickNotesConfig);
                    getDefaultProjectName(jsonQuickNotesConfig.defaultProject?.id,jsonQuickNotesConfig);
                })
            }else{
                setQuickNoteDefaultConfig(jsonQuickNotesConfig);
                getDefaultProjectName(jsonQuickNotesConfig.defaultProject?.id,jsonQuickNotesConfig);
            }

        }else{
            getDefaultProjectName(null);
        }

        //自动更新时间。。。
        setAutoBackupInterval(localStorage.getItem(KEY_AUTO_BACKUP_INTERVAL) || (DB_AUTO_BACKUP_TIME+''));
    }

    useEffect(()=>{
        const lang = navigator.language;
        const e8 = checkTimeZone();
        if (lang.startsWith('zh') || e8){
            setHasCommunity(false);
        }

        //读取左侧菜单
        const szLeftMenu = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);
        if (szLeftMenu){
            const jsonMenu = JSON.parse(szLeftMenu);
            if (jsonMenu.properties == undefined){
                jsonMenu.properties = true;
            }
            setHomeLeftMenu(jsonMenu);
        }


        getSysConfig(SYS_CONFIG_KEY_AUTOUPDATE).then(res=>{
            if(res?.value != 'false'){
                setIsAutoUpdate(true);
            }else{
                setIsAutoUpdate(false);
            }
        })
        // getSysConfig(SYS_CONFIG_KEY_THEME).then(res=>{
        //     if(res != undefined && res.value){
        //         let itemTheme = arrayDarkMenu.find(p=>p.key == res.value);
        //         setThemeName(itemTheme.label);
        //     }
        // })
        const theme = localStorage.getItem(SYS_CONFIG_KEY_THEME);
        if (theme){
            let itemTheme = arrayDarkMenu().find(p=>p.key == theme);
            setThemeName(itemTheme.label);
        }

        let szFormat = localStorage.getItem(SYS_CONFIG_KEY_DATEFORMAT) || "dd/MM/yyyy";
        updateDateformat(szFormat);

        const langCode = localStorage.getItem(SYS_CONFIG_KEY_LANGUAGE_CODE);
        if (langCode){
            updateLanguage(langCode);
        }

        recvMessage(EVENT_REFRESH_LOGIN_STATUS,()=>{
            refreshLoginStatus()
        },false);

        //刷新登录.
        recvMessage(EVENT_REFRESH_USER_IFNO,()=>{
            queryUserInfo()
        })

        const isDev = localStorage.getItem(SYS_CONFIG_DEV_MODE);
        setIsDevMode(isDev == 'true');

        setIsEnableSync(localStorage.getItem(KEY_IS_ENABLE_SYNC) == 'true');
        setIsEnableAutoBackup(localStorage.getItem(KEY_ENABLE_AUTO_BACKUP) != 'false');

        if (!backupPath){
            ipcInvoke('get-default-backup-dir').then(res=>{
                setBackupPath(res);
            })
        }

        const autoBackupPath0 = localStorage.getItem(KEY_AUTO_BACKUP_PATH)??'';
        setAutoBackupPath(autoBackupPath0);
        if (!autoBackupPath0){
            ipcInvoke('get-default-auto-backup-dir').then(res=>{
                localStorage.setItem(KEY_AUTO_BACKUP_PATH,res);
                setAutoBackupPath(res);
            })
        }

        refreshLoginStatus();

    },[])

    useEffect(()=>{
        setIsAdvanceChecked(importFileMode == 'advanced')
    },[importFileMode])

    useEffect(() => {
        global.g_showDialogs['settingIndex'] = isShowSettingDialog;
    }, [isShowSettingDialog]);

    useEffect(() => {
        //重置.
        const arrayNewShortcutsConfig = [...shortcutsConfig];
        resetShortcutConfigPressed(arrayNewShortcutsConfig);
        setShortcutsConfig(arrayNewShortcutsConfig);
    }, [currentMenu]);

    useEffect(()=>{
        if (!isWeb()){
            ipcInvoke('app-version').then((args)=>{
                setCurrentVersion('V'+args);
            })
            ipcOn('app-update-message',updateProgressMessage);

            /**
             * 读取的DB流....
             */
            ipcOn('restore-db-stream',onDbRestore);
            ipcOn('restore-progress',(event,args)=>{
                console.log('restore-progress:'+args.progress)
                setIsRestoring(true);
                mRestoreFileProgress = args.progress;
                setRestoreProgress((mRestoreFileProgress + mRestoreDbDataProgress)/2);
                if (args.progress >= 1){
                    mIsRestoreFileComplete = true;
                }
                onRestoreSuccess();
            })
            ipcOn('restore-error',(event,args)=>{
                message.error(t("InvalidBackupFile"))
            })
            //备份进度...
            ipcOn('backup-progress',onBackupProgress)
        }

        document.body.addEventListener('keydown',onKeydown)

        return ()=>{
            ipcRemoveThisAll('restore-db-stream');
            ipcRemoveThisAll('backup-progress');
            ipcRemoveThisAll('restore-progress');
            ipcRemoveThisAll('app-update-message');
            ipcRemoveThisAll('restore-error');
            document.body.removeEventListener('keydown',onKeydown);
        }
    })

    function getOriginalKey(specialChar) {
        const mapping = {
            'å': 'a', '∫': 'b', 'ç': 'c', '∂': 'd', '´': 'e',
            'ƒ': 'f', '©': 'g', '˙': 'h', 'ˆ': 'i', '∆': 'j',
            '˚': 'k', '¬': 'l', 'µ': 'm', '˜': 'n', 'ø': 'o',
            'π': 'p', 'œ': 'q', '®': 'r', 'ß': 's', '†': 't',
            '¨': 'u', '√': 'v', '∑': 'w', '≈': 'x', '¥': 'y',
            'Ω': 'z'
        };
        return mapping[specialChar] || specialChar;
    }

    const macOptionShiftMappings = {
        'Å': 'A',  // Option+Shift+A
        'ı': 'B',  // Option+Shift+B
        'Ç': 'C',  // Option+Shift+C
        'Î': 'D',  // Option+Shift+D
        '´': 'E',  // Option+Shift+E
        'Ï': 'F',  // Option+Shift+F
        '˝': 'G',  // Option+Shift+G
        'Ó': 'H',  // Option+Shift+H
        'ˆ': 'I',  // Option+Shift+I
        'Ô': 'J',  // Option+Shift+J
        '': 'K',  // Option+Shift+K (苹果符号)
        'Ò': 'L',  // Option+Shift+L
        'Â': 'M',  // Option+Shift+M
        '˜': 'N',  // Option+Shift+N
        'Ø': 'O',  // Option+Shift+O
        '∏': 'P',  // Option+Shift+P
        'Œ': 'Q',  // Option+Shift+Q
        '‰': 'R',  // Option+Shift+R
        'Í': 'S',  // Option+Shift+S
        'ˇ': 'T',  // Option+Shift+T
        '¨': 'U',  // Option+Shift+U
        '◊': 'V',  // Option+Shift+V
        '„': 'W',  // Option+Shift+W
        '˛': 'X',  // Option+Shift+X
        'Á': 'Y',  // Option+Shift+Y
        '¸': 'Z'   // Option+Shift+Z
    };


    function onKeydown(event:any){
        if (event.key == KEYS.ESCAPE){
            const shortcutsConfigNew = [...shortcutsConfig];
            const shortcut = shortcutsConfigNew.find(p=>p.isPressed);
            if (shortcut){
                shortcut.isPressed = false;
                setShortcutsConfig(shortcutsConfigNew);
            }else{
                setIsShowSettingDialog(false);
            }
        }else{
            //取当前编辑状态中的..
            let szKey = event.key.toUpperCase();
            if (szKey.length != 1){
                szKey = '';
            }
            const shortcutsConfigNew = [...shortcutsConfig];
            const shortcut:any = shortcutsConfigNew.find(p=>p.isPressed);
            if (shortcut){
                const isCtrl = (event.metaKey || event.ctrlKey)?'Ctrl + ':'';
                const isAlt = event.altKey?'Alt + ':'';
                const isShift = event.shiftKey?'Shift + ':'';
                if (isMac() && event.altKey){
                    szKey = getOriginalKey(szKey.toLowerCase()).toUpperCase();
                }
                // if (isMac() && event.altKey && event.shiftKey){
                //     szKey = macOptionShiftMappings[szKey.toUpperCase()] || szKey;
                // }
                if (szKey){
                    let szNewShortcut =getCtrlOrAltCmd(isCtrl) + getCtrlOrAltCmd(isAlt) + isShift + szKey;
                    //判断是否有重复的.
                    for (let i=0;i<GET_ARRAY_SHORTCUTS().length;i++){
                        const item = GET_ARRAY_SHORTCUTS()[i];
                        for (let j=0;j<item.children.length;j++){
                            const subItem = item.children[j];
                            if (subItem.key == szNewShortcut && subItem.name != 'Card'){
                                message.destroy();
                                message.error(t('ShortcutsExist'));
                                return;
                            }
                        }
                    }
                    //跟另外2个也不能重
                    const arrayOthers = shortcutsConfigNew.filter(p=>!p.isPressed);
                    for (let i=0;i<arrayOthers.length;i++){
                        const item = arrayOthers[i];
                        if (item.shortcuts == szNewShortcut){
                            message.destroy();
                            message.error(t('ShortcutsExist'));
                            return;
                        }
                    }
                    shortcut.shortcuts = szNewShortcut;
                    shortcut.isPressed = false;
                    setShortcutsConfig(shortcutsConfigNew);
                    //保存...
                    localStorage.setItem(KEY_GLOBAL_SHORTCUTS_CONFIG,JSON.stringify(shortcutsConfigNew));
                    //如果是浮窗的
                    if (shortcut.name == 'quickNotes'){
                        ipcInvoke('re-shortcuts',{shortcut:shortcut.shortcuts})
                    }
                }

            }
        }
    }


    /**
     * 还原的操作。。覆盖.....
     * @param event
     * @param args
     */
    const onDbRestore = (event,args)=>{
        const blob = new Blob([new Uint8Array(args.arrayBufs, 0, args.arrayBufs.length)]);
        importDb(blob,(progress:any)=>{
            mRestoreDbDataProgress = progress.completedRows / progress.totalRows;
            console.log('import progress...'+mRestoreDbDataProgress);
            setRestoreProgress((mRestoreDbDataProgress+mRestoreFileProgress)/2)
            if (progress.completedRows == progress.totalRows){
                console.log('progress.completedRows == progress.totalRows')
            }
        }).then(res=>{
            mIsRestoreDbComplete = true;
            onRestoreSuccess();
        }).catch(e=>{
            message.error('restore error');
        });
    }

    /**
     * 恢复成功
     */
    const onRestoreSuccess = async ()=>{
        if (mIsRestoreDbComplete && mIsRestoreFileComplete){
            message.success(t("Restore success"));
            setIsShowSettingDialog(false);
            setIsRestoring(false);
            //这里重新加载property-如果没有的话..
            await initDefaultProperty();

            postMessage(EVENT_NOTE_CHANGED);//刷新card...
            postMessage(EVENT_REFRESH_LIBRARY_LIST);//或者list
            postMessage(EVENT_FAVIRIATE_CHANGE);//刷新收藏 ...
            //读取菜单配置并刷新
            postMessage(EVENT_REFRESH_HOME_LEFT_MENU);
            //刷新菜单
            getSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE).then(res=>{
                if (res?.value){
                    if (res?.value?.properties == undefined){
                        res.value.properties = true;
                    }
                    setHomeLeftMenu(res.value);
                }
            });
            //清历史记录
            clearProjectHistoryDoc();

            mIsRestoreDbComplete = mIsRestoreFileComplete = false;
            mRestoreDbDataProgress = mRestoreFileProgress = 0;
        }
    }

    function onBackupProgress(event,args){
        //导出数据库占50%，压缩文件占50%  ok...
        if (mBackupMode == 'full'){
            const fProgress = args.progress/2;
            setBackupProgress(0.5+fProgress);
            // console.log('progress....'+(0.5+fProgress));
            if ((0.5+fProgress) >= 1.0){
                //结束....
                setIsBackuping(false);
                // message.destroy();
                if (!mIsShowBackupSuccess){
                    message.info(t('Backup success'));
                }
                mIsShowBackupSuccess = true;
                setIsShowBackupFinishedView(true);
                mszBackupPath = args.filePath;
                setTimeout(()=>{
                    setIsShowBackupFinishedView(false)
                },10000);
            }
        }else if (mBackupMode == 'onlyDb'){
            const fProgress = args.progress/2;
            setBackupProgress(0.5+fProgress);
            // console.log('progress....'+(0.5+fProgress));
            if ((0.5 + fProgress) >= 1.0){
                //结束....
                setIsAutoBackuping(false);
                // message.destroy();
                if (!mIsShowBackupSuccess){
                    message.info(t('Backup success'));
                }

                mszAutoBackupPath = args.filePath;
                setIsShowAutoBackupFinishedView(true);
                mIsShowBackupSuccess = true;

                setTimeout(()=>{
                    setIsShowAutoBackupFinishedView(false)
                },10000);
            }
        }

    }


    /**
     * 显示登录
     */
    const onShowLogin = ()=>{
        setIsLoginDialogShow(true)
    }

    /**
     * 刷新上次同步时间
     */
    const refreshLastSyncTime = ()=>{
        const lastSync = localStorage.getItem(KEY_LAST_SYNC_TIME);
        if (lastSync){
            setSyncInfo(t("LastSyncTime")+":"+lastSync);
        }else{
            setSyncInfo('');
        }
    }

    /**
     * 刷新登录状态
     */
    const refreshLoginStatus = ()=>{
        // const szToken = localStorage.getItem(ACCESS_TOKEN);
        var isSuccess = Global.g_userInfo != undefined;//!isStringNullOrEmpty(szToken);
        if (isSuccess){
            setIsLoginSuccess(true);
            setLoginAccountDesc(t("You are currently signed in")+Global.g_userInfo.username+"("+Global.g_userInfo.email+")")
        }else{
            setIsLoginSuccess(false);
            setLoginAccountDesc(t("No login no publish"));
        }
        setUserInfo(Global.g_userInfo);
        updateLicenseInfo();
        return isSuccess;
    }

    /**
     * 更新日期格式
     * @param szDateformat
     */
    const updateDateformat = (szDateformat)=>{
        let date = new Date();
        setDateFormat(formatDate(date,szDateformat));
    }

    const onAutoUpdateChanged = (value)=>{
        setIsAutoUpdate(value);
        updateSysConfig(SYS_CONFIG_KEY_AUTOUPDATE,value?'true':'false');
    }

    //更新主题
    //修复主题
    //修改主题
    //更改主题
    const onThemeClick = (item)=>{
        let itemTheme = arrayDarkMenu().find(p=>p.key == item.key);
        setThemeName(itemTheme.label);
        // updateSysConfig(SYS_CONFIG_KEY_THEME,item.key);
        localStorage.setItem(SYS_CONFIG_KEY_THEME,item.key);
        global.g_isDarkMode = (item.key == THEME_DARK);
        const szThemeName = item.key + '-theme';
        let body = document.getElementsByTagName("body")[0];
        body.className = szThemeName;
        emitter.emit(EVENT_CHANGE_THEME,item.key);
        postMessage(EVENT_FORCE_UPDATE);
        window.globalRefreshList('updateTheme_');
        //通知floatwindow
        ipcInvoke('notify-theme-change');
    }

    const onDateformatClick = (item)=>{
        updateDateformat(item.key);
        // updateSysConfig(SYS_CONFIG_KEY_DATEFORMAT,item.key);
        localStorage.setItem(SYS_CONFIG_KEY_DATEFORMAT,item.key);
        Global.g_dateFormat = item.key;
        postMessage(EVENT_NOTE_CHANGED)
    }

    //多语言修改
    const onLanguageClick = (item)=>{
        updateLanguage(item.key);
        updateSysConfig(SYS_CONFIG_KEY_LANGUAGE_CODE,item.key);
        switchLanguage(item.key);

        //插入一些额外的样式表...
        var style = document.createElement('style');
        document.head.appendChild(style);
        if (style.sheet){
            style.sheet.insertRule(`.ProseMirror-focused p.is-empty::before{content:"${isInSingleFloatWindow()?'':t("InsertBlock")}"}`,0)
            style.sheet.insertRule(`.ProseMirror-focused h1.is-empty::before{content:"${t("H1")}"}`,1)
            style.sheet.insertRule(`.ProseMirror-focused h2.is-empty::before{content:"${t("H2")}"}`,2)
            style.sheet.insertRule(`.ProseMirror-focused h3.is-empty::before{content:"${t("H3")}"}`,3)
        }

        postMessage(EVENT_LANGUAGE_CHANGED)
        ipcInvoke('notify-language-change',{languageCode:item.key});
        window.globalRefreshList('refresh_language_');

        setUpdateInfo(t("You used latest version"));
        setUpdateProgress(t('Check update'));
        refreshLoginStatus();
        // setArrayThemeOptions(arrayDarkMenu());

        const szTheme = localStorage.getItem(SYS_CONFIG_KEY_THEME) || 'light';
        let itemTheme = arrayDarkMenu().find(p=>p.key == szTheme);
        setThemeName(itemTheme?.label);
        // setRandomKey(generateUUID2())
        // forceUpdate();
    }

    const updateLanguage = (szLangCode:string)=>{
        localStorage.setItem(SYS_CONFIG_KEY_LANGUAGE_CODE,szLangCode);
        for(var i=0;i<arrayLanguages.length;i++){
            var itemLang = arrayLanguages[i];
            if (szLangCode == itemLang.key){
                setLanguageName(itemLang.label);
                break;
            }
        }
    }
    //登录对话框关闭
    const onCloseLoginDialog = (szToken)=>{
        setIsLoginDialogShow(false);
        // const szToken = localStorage.getItem(ACCESS_TOKEN);
        if(!isStringNullOrEmpty(szToken)){
            //请求用户信息
            queryUserInfo();
        }
    }

    /**
     * 查询用户信息
     */
    const queryUserInfo= ()=>{
        // if (mIsQuering)return;
        mIsQuering = true;
        return new Promise((resolve, reject) => {
            getUserInfo({},()=>{
                mIsQuering = false;
                reject();
            }).then((res:any)=>{
                mIsQuering = false;

                Global.g_userInfo = res;
                console.log(res);
                setUserInfo(res);
                //刷新登录状态
                refreshLoginStatus();

                resolve('');
            })
        })
    }

    //显示登录框
    const activityLic = async (szLicType:string)=>{
        if(Global.g_userInfo == undefined){
            messageApi.info("请登录");
            setIsLoginDialogShow(true);
            return;
        }
        if ('comLic' === szLicType){
            setIsComLicLoading(true);
        }else if('pubLic' == szLicType){
            setIsPubLicLoading(true);
        }
        //重新请求用户信息
        await queryUserInfo();

        setIsComLicLoading(false);
        setIsPubLicLoading(false);
    }

    //退出登录
    const logout = ()=>{
        // Modal.confirm({
        //     icon: <ExclamationCircleFilled />,
        //     content:t("Confirm logout"),
        //     okText:t("Logout"),
        //     cancelText:t("Cancel"),
        //     okType:"danger",
        //     centered:true,
        //     onOk(){
        //         localStorage.removeItem(ACCESS_TOKEN);
        //         localStorage.removeItem(KEY_USER_INFO);
        //         Global.g_userInfo = undefined;
        //         setUserInfo(undefined);
        //         refreshLoginStatus();
        //     },
        //     onCancel(){
        //
        //     }
        // })
        dialogMessageBoxRef?.current?.onShowDialog(t("Confirm logout"),t("DataCantBeSync"),t("Logout"),()=>{
                localStorage.removeItem(ACCESS_TOKEN);
                localStorage.removeItem(KEY_USER_INFO);
                Global.g_userInfo = undefined;
                setUserInfo(undefined);
                refreshLoginStatus();
        });
    }

    /**
     * 转到购买
     */
    const navPurchaseUrl = ()=>{
        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_VIP);
    }

    /**
     * 检查更新
     */
    const checkUpdate = ()=>{
        setIsCheckingUpdate(true);
        ipcSend('check-update',{});
    }

    const onLoginOrReg= ()=>{
        if (import.meta.env.DEV){
            setIsLoginDialogShow(true);
        }
        ipcSend("open-url",import.meta.env.VITE_HTTP_REGISTER_URL)
    }

    const navUrl = (szUrl:any,szZhUrl:any=null)=>{
        if (szZhUrl){
            if (isZh()){
                ipcSend('open-url',szZhUrl);
                return;
            }
        }
        ipcSend('open-url',szUrl)
    }
    /**
     * 渲染登录/未登录
     */
    const renderLoginStatus = ()=>{
        if (isLoginSuccess){
            return(
                <Space size={"middle"}>
                    {/*<Button onClick={()=>ipcSend("open-url",import.meta.env.VITE_HTTP_ACCOUNT_MANAGER)}>{t('Manager setting')}</Button>*/}
                    <div className='font-size-12 button-border-gray-style hovered-border-8 flex-center setting-button-style' style={{height:'28px',minWidth:'126px',border:'1px solid var(--setting-button-border-color)'}} onClick={()=>logout()}>{t("Logout")}</div>
                </Space>
            )
        }else{
            return(
                <Space size={"middle"}>
                    {/*<Button onClick={()=>setIsLoginDialogShow(true)}>{t("Login")}</Button>*/}
                    <div className='font-size-12 button-border-gray-style hovered-border-8 flex-center'
                         style={{height:'28px',minWidth:'126px'}} onClick={()=>onLoginOrReg()}>{t("Login")+"/"+t("Register")}</div>
                </Space>
            )
        }
    }

    const renderCommercialLicense = ()=>{
        if(userInfo != undefined && userInfo.commercialLicense != null){
            return(
                <Button  className='button-solid-style font-size-12' type={"primary"} onClick={()=>navPurchaseUrl()}>Details</Button>
            )
        }else{
            return(
                <Space size={"middle"}>
                    <Button className='font-size-12' loading={isComLicLoading} onClick={()=>activityLic('comLic')}>{t("Active")}</Button>
                    <Button className='button-solid-style font-size-12' type={"primary"} onClick={()=>navPurchaseUrl()}>{t("Purchase")}</Button>
                </Space>
            )
        }
    }

    const renderPublisherLicense = ()=>{
        if(userInfo != undefined && userInfo.publisherLicense != null){
            return(
                <Button className='font-size-12' type={"primary"} onClick={()=>navPurchaseUrl()}>{t("Details")}</Button>
            )
        }else{
            return(
                <Space size={"middle"}>
                    <Button className='font-size-12' loading={isPubLicLoading} onClick={()=>activityLic('pubLic')}>{t("Active")}</Button>
                    <Button className='button-solid-style font-size-12' type={"primary"} onClick={()=>navPurchaseUrl()}>{t("Purchase")}</Button>
                </Space>
            )
        }
    }


    /**
     * 不用不用不用不用不用不用不用不用不用不用不用不用不用不用
     */
    const updateLicenseInfo = ()=>{
        let szLicInfo = t("Please login first");
        if (Global.g_userInfo != null){
            if(!isStringNullOrEmpty(Global.g_userInfo.commercialLicense)){
                // return (
                //     <span className='var-gray-7'>{t("Commercial license")+":"+t("Active")}</span>
                // )
                szLicInfo = (t("Commercial license")+":"+t("Active"))+"\n";
            }else if (!isStringNullOrEmpty(Global.g_userInfo.publisherLicense)){
                // return (
                //     <span className='var-gray-7'>{t("Publisher license")+":"+t("Active")}</span>
                // )
                szLicInfo += (t("Publisher license")+":"+t("Active"))+"\n";
            }else if (!isStringNullOrEmpty(Global.g_userInfo.desktopProLicense)){
                szLicInfo += (t("Desktop pro license")+":"+t("Active"))+"\n";
            }else if (!isStringNullOrEmpty(Global.g_userInfo.desktopProPlusLicense)){
                szLicInfo += (t("Desktop pro plus license")+":"+t("Active"))+"\n";
            }else if (!isStringNullOrEmpty(Global.g_userInfo.desktopProMaxLicense)){
                szLicInfo += t("Desktop Pro Max")+":"+t("Active")+"\n";
            }else if (!isStringNullOrEmpty(Global.g_userInfo.premiumLicense)){
                szLicInfo += t("Premium plan")+":"+t("Active")+"\n";
            }else if (!isEmptyStringObject(Global.g_userInfo.desktopProBasicLicense)){
                szLicInfo += t("Desktop pro basic license")+":"+t("Active")+"\n";
            }
            else {
                // return (
                //     <span className='var-gray-7'>{t("No license available")}</span>
                // )
                szLicInfo = (t("No license available"));
            }
        }else{
            szLicInfo = (t("Please login first"))
        }
        if (szLicInfo.endsWith('\n')){
            szLicInfo = szLicInfo.substring(0,szLicInfo.length -1)
        }
        setLicenseInfoDesc(szLicInfo);
    }

    const renderLicense = ()=>{
        if(Global?.g_userInfo == undefined){
            return(
                <span className='var-gray-7 mt-4'>{t("Please login first")}</span>
            )
        }else{
            if (!hasLicense() && !hasPublishLicense() && !hasDesktopBaseLicense()){
                return <div className={'flex-row-vertical-center mt-4'}>
                    <span className='var-gray-7 '>{t("NoLicenseAvailable")}</span>
                    <img className={'img-14 ml-4 cursor-pointer'} src={getImagePathWithTheme('gray_helper')} onClick={(event)=>{
                        dialogLicenseHelperRef.current?.onShowDialog();
                    }}/>
                </div>
            }else{
                var arrayLics = [];
                arrayLics.push(<span className='mt-4' key={generateUUID2()}></span>)
                if (!isStringNullOrEmpty(Global.g_userInfo.commercialLicense)){
                    arrayLics.push(<span key={'commercialLicense'} className='var-gray-7'>{t("Commercial license")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.publisherLicense)){
                    arrayLics.push(<span key={'publisherLicense'} className='var-gray-7'>{t("Publisher license")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.publisher4BizLicense)){
                    arrayLics.push(<span key={'publisher4BizLicense'} className='var-gray-7'>{t("Publisher for business")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.desktopProLicense)){
                    arrayLics.push(<span key={'desktopProLicense'} className='var-gray-7'>{t("Desktop pro license")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.desktopProPlusLicense)){
                    arrayLics.push(<span key={'desktopProPlusLicense'} className='var-gray-7'>{t("Desktop pro plus license")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.desktopProMaxLicense)){
                    arrayLics.push(<span key={'desktopProMaxLicense'} className='var-gray-7'>{t("Desktop Pro Max")+":"+t("Active")}</span>)
                }
                if (!isStringNullOrEmpty(Global.g_userInfo?.premiumLicense)){
                    arrayLics.push(<span key={'premiumLicense'} className='var-gray-7'>{t("Premium plan")+":"+t("Active")}</span>)
                }else if (!isEmptyStringObject(Global.g_userInfo.desktopProBasicLicense)){
                    arrayLics.push(<span key={'desktopProBasicLicense'} className='var-gray-7'>{t("Desktop pro basic license")+":"+t("Active")}</span>)
                }
                return arrayLics;
            }
        }
    }

    /**
     * 要备份的全部文件路径
     */
    const getAllFilePaths = async ()=>{
        let arrayFiles:any = [];
        const arrayCards:any = await getAllCardList();
        const szDir = localStorage.getItem(KEY_FILE_DIR);
        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            if (item.fileName){
                const szPath = szDir + item.fileName;
                arrayFiles.push(szPath);
            }
            //缩略图....
            if (item.thumbImage && !item.isAbsolutePath/*item.thumbImage.startsWith("localfile://")*/){
                arrayFiles.push(szDir + item.thumbImage.replace('localfile://',''))
            }
            if (item.type == 'card' || item.type == 'journal'){
                const doc = await getCardDoc(item.id);
                let arrayImgs:any = getImageFileNameListFromDoc(doc);
                arrayImgs.forEach(p=>{
                    arrayFiles.push(szDir+p);
                })
            }
        }

        //所有board
        const arrayBoards = await getBoardList('');
        for (let i=0;i<arrayBoards.length;i++){
            const board = arrayBoards[i];
            if (board.thumbUrl){
                arrayFiles.push(szDir + board.thumbUrl.replace('localfile://',''))
            }
        }

        //todo 备份所有的图片以及缩略图文件..
        const arrayProjects:any = await getNoteList();
        for (let i=0;i<arrayProjects.length;i++){
            const item = arrayProjects[i];
            const docData = await getNoteDoc(item.id);
            if (!docData)continue;
            const doc = JSON.parse(docData.doc);
            loopAllNodeAsync(doc.canvas,async (item)=>{
                if (item.drawJson?.elements){
                    const arrayImageFiles = item.drawJson.files;
                    const arrayValues = Object.values(arrayImageFiles);
                    for (let k=0;k<arrayValues.length;k++){
                        const file = arrayValues[k];
                        const szPath = szDir + file.id + '.'+extFromMineType(file.mimeType);
                        arrayFiles.push(szPath);
                    }
                    const elements = item.drawJson?.elements;
                    for (let i=0;i<elements.length;i++){
                        const element = elements[i];
                        if (isProjectLinkElement(element)){//项目链接的缩略图---不在库里面.
                            if (element.customData?.thumbImage){
                                const szPath = szDir + getFileName(element.customData.thumbImage);
                                arrayFiles.push(szPath);
                            }
                        }else if (isTextElement(element) || isStickyNotesElement(element)){
                            const doc = await getTiptapDoc(element.id);
                            let arrayImgs:any = getImageFileNameListFromDoc(doc?.doc);
                            arrayImgs.forEach(p=>{
                                arrayFiles.push(szDir+p);
                            })
                        }
                    }
                }
            })

            //项目的缩略图...
            if (item.thumbUrl){
                if (item.thumbUrl.startsWith('localfile://')){
                    arrayFiles.push(szDir + item.thumbUrl.replace('localfile://',''))
                }
            }
        }

        return arrayFiles;
    }

    /**
     * 使用云盘数据恢复
     * @param arrayBufs
     */
    const restoreUseCloud = (arrayBufs:any)=>{
        window.showIndicator('恢复中...');
        //云盘中的文件最新
        const blob = new Blob([new Uint8Array(arrayBufs, 0, arrayBufs.length)]);
        restoreDbNoClear(blob,(progress:any)=>{
            if (progress.completedRows == progress.totalRows){
                postMessage(EVENT_NOTE_CHANGED);//刷新card...
                postMessage(EVENT_REFRESH_LIBRARY_LIST);//或者list
                postMessage(EVENT_FAVIRIATE_CHANGE);//刷新收藏 ...

                message.success(t("Sync success"));
                window.closeIndicator();
                setIsShowSettingDialog(false);
            }
        }).then(res=>{
            console.log('auto-restore');
            console.log(res);
        });
    }

    /**
     * 手动恢复
     */
    const restore = (filter:any,szBackupPath:any)=>{
        if (isRestoring) return;
        window.showMessageBox(t("Restore from backups"),t("UploadTheFileAllData")+'</br>'+t("WarningUpload"),t("Cancel"),t("Upload file"),null,()=>{
            //直接回首页
            if (isInDraw()){
                window.navPage('recent');
            }
            ipcInvoke('restore', {filter:filter,filePath:szBackupPath});
        })
    }

    /**
     * 订制的菜单点击
     * @param szKey
     * @param checked
     */
    const onSwitchCustomize = (szKey:any,checked:any)=>{
        var arrayNew:any = {...homeLeftMenu};
        arrayNew[szKey] = checked;
        setHomeLeftMenu(arrayNew);
    }

    /**
     * 重置为未选中...
     */
    const resetShortcutConfigPressed = (shortcutsConfig:any)=>{
        shortcutsConfig.forEach(p=>{
            p.isPressed = false;
        })
    }

    /**
     * quicknotes的默认标签
     */
    const getDefaultTags = ()=>{
        let szTags = t('None');
        if(quickNoteDefaultConfig.defaultTags){
            szTags = quickNoteDefaultConfig.defaultTags.map(p=>{
                return '#'+p
            }).join(', ')
        }
        return szTags;
    }

    /**
     * 默认的项目名称
     */
    const getDefaultProjectName = (szProjectId,jsonQuickConfig)=>{
        if (szProjectId){
            getProjectById(szProjectId).then(res=>{
                if (res && res.isDeleted == 0){
                    setDefaultQuickNoteProjectName(res.name || t('Untitled'));
                }else{
                    setDefaultQuickNoteProjectName(t('None'));
                    if (jsonQuickConfig){
                        delete jsonQuickConfig.defaultProject;
                        localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(jsonQuickConfig));
                    }
                }
            })
        }else{
            setDefaultQuickNoteProjectName(t('None'));
        }
    }

    /**
     * 清除快捷键
     * @param nShortCutIndex
     */
    const clearShortcuts = (nShortCutIndex)=>{
        const newConfig = [...shortcutsConfig];
        resetShortcutConfigPressed(newConfig);
        newConfig[nShortCutIndex].shortcuts = '';
        setShortcutsConfig(newConfig);

        //保存...
        localStorage.setItem(KEY_GLOBAL_SHORTCUTS_CONFIG,JSON.stringify(newConfig));
    }

    return(
        <Modal style={{borderRadius:'0px',padding:'0px',overflowX:'hidden', overflowY:'auto'}}
               className='dialog-background'
               keyboard={false}
               destroyOnClose={true} width='877px'
               title="" open={isShowSettingDialog}
               closable={false} footer={''}
               // closeIcon={<img className='img-mini-small-10 cursor-pointer' style={{margin:'-10px -10px 0 0'}}
               //                 src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")}/>}
               maskClosable={true}
               centered={true}
               onCancel={() => {
                   global.g_showDialogs['settingIndex'] = false;
                   setIsShowSettingDialog(false)
               }}
               afterOpenChange={(b)=>{

               }}>

            {/*0.01px auto*/}
            {/*gridTemplateColumns:'180px 1px auto'*/}
            {/*和下面的div line 一起恢复*/}
            <div className={'default-font-family'} key={randomKey}
                 style={{display: 'grid', gridTemplateColumns: '180px 1px auto', fontSize: '12px',position:'relative',textWrap:'nowrap',textOverflow:'ellipsis'}}>
                {contextHolder}
                <div style={{opacity: '1'}}>
                <span
                    style={{color: userInfo ? 'var(--text-color)' : 'var(--color-999)',marginLeft:'-4px'}}>{userInfo ? userInfo.email : t("Not logged in")}</span>
                    <div className='hovered border-radius-8 set-left-menu mt-12' onClick={() => {
                        setCurrentMenu('general')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'general' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'general' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("General")}
                        </div>
                    </div>

                    {/*home preference*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('homePreference')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'homePreference' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'homePreference' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("HomePreference")}
                        </div>
                    </div>

                    {/*global preference*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('globalPreference')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'globalPreference' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'globalPreference' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Global Preferences")}
                        </div>
                    </div>

                    {/*backup*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('backup')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'backup' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'backup' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Backup & Restore")}
                        </div>
                    </div>

                    {/*Sync*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('sync')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'sync' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'sync' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Sync")}
                        </div>
                    </div>

                    {/*importFile*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('importFile')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'importFile' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'importFile' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Import file")}
                        </div>
                    </div>

                    {/*Shortcuts Setting*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('shortcutsSetting')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'shortcutsSetting' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'shortcutsSetting' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Shortcuts Setting")}
                        </div>
                    </div>

                    {/*Web viewer*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('webview')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'webview' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'webview' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Web viewer")}
                        </div>
                    </div>

                    {/*Quick note settings*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('quickNote')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'quickNote' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'quickNote' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("Quick note")}
                        </div>
                    </div>

                    {/*about*/}
                    <div className='hovered border-radius-8 set-left-menu' onClick={() => {
                        setCurrentMenu('about')
                    }}>
                        <div className={'font-family-medium'} style={{
                            width: '100%',
                            height: '100%',
                            background: currentMenu == 'about' ? 'var(--hover-background-color)' : 'transparent',
                            color: currentMenu == 'about' ? '#3670F7' : 'var(--text-color)'
                        }}>
                            {t("About")}
                        </div>
                    </div>
                </div>

                <div style={{height: '120%', width: '1px', background: 'var(--line-color)', margin: '-22px 0'}}></div>

                <div style={{position: 'relative'}}>
                    <div className={style.spanFontSize + ' container font-size-12'} style={{
                        // margin: '1px 20px',
                        visibility: currentMenu == 'general' ? 'visible' : 'hidden',
                        opacity: currentMenu == 'general' ? '1' : '0',
                        padding:'0 36px'
                    }}>
                        {
                            //backup 模式需要注释的头部
                            // <>
                            //     <div>
                            //         <span className='font-size-18-w500'>{t("Settings")}</span>
                            //         <span style={{color: 'red'}}>{isDevMode ? '(测试模式)' : ''}</span>
                            //     </div>
                            //     <div className={'line mt-12'} style={{marginLeft: '-44px', marginRight: '-44px'}}></div>
                            // </>
                        }

                        <span className='item-margin bt-gray padding-bottom-6 font-size-18-w500 font-family-medium'
                              onClick={() => {
                                  if ((Date.now() - mFirstClickTime) > 3000) {
                                      mClickTimes = 0;
                                  }

                                  //3s点击5次
                                  if (mClickTimes === 0) {
                                      mFirstClickTime = Date.now();
                                  }
                                  mClickTimes++;
                                  if ((Date.now() - mFirstClickTime) <= 3000 && mClickTimes >= 5) {

                                      const isDev = localStorage.getItem(SYS_CONFIG_DEV_MODE);
                                      setIsDevMode(isDev != 'true');

                                      if (isDev == 'true') {
                                          message.info("开发者模式已关闭，连接正式服");
                                          localStorage.setItem(SYS_CONFIG_DEV_MODE, 'false');
                                      } else {
                                          message.info("开发者模式已开启，连接测试服");
                                          localStorage.setItem(SYS_CONFIG_DEV_MODE, 'true');
                                      }
                                      switchBaseURL();
                                      mClickTimes = 0;
                                  }
                              }} onMouseDown={(event) => {
                            mIsDownPressed = true;
                            mMouseDownloadTime = Date.now();
                            setTimeout(() => {
                                if (/*isDevMode &&*/ mIsDownPressed && event.buttons == 1 && (Date.now() - mMouseDownloadTime) > 6000) {
                                    ipcInvoke('open-dev');
                                    mMouseDownloadTime = 0;
                                }
                                mIsDownPressed = false;
                            }, 6000)
                        }} onMouseUp={() => {
                            mIsDownPressed = false;
                        }}>{t("App") + (isDevMode ? '(测试模式)' : '')}</span>
                        <div className='mt-8' style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{display: 'flex', flexGrow: '1', flexDirection: 'column'}}>
                            <span
                                className='large-text font-size-18-w400'>{t("Current version")}:{currentVersion}</span>
                                <div className='flex-item mt-4'>
                                    <span className='var-gray-7'>{updateInfo}</span>
                                    <span onClick={() => {
                                        if (isZh()) {
                                            ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG_ZH);
                                        }else {
                                            ipcSend('open-url', import.meta.env.VITE_HTTP_CHANGE_LOG);
                                        }

                                    }}
                                          className='link-color font-size-12 ml-12 cursor-pointer'>{t("Read update log")}</span>
                                </div>

                            </div>
                            <Button className='button-solid-style font-size-12'
                                    style={{height: '28px', padding: '2px 12px 2px 12px', minWidth: '126px'}}
                                    type="primary"
                                    onClick={() => {

                                        if (import.meta.env.DEV) {
                                            dialogUpdateRef.current?.onShowDialog();
                                        }
                                        if (isZh()) {
                                            window.showMessageBox("温馨提示：", '<div class="flex-col"><span>  由于我们的更新服务器位于GitHub，国内用户可能需要开启科学上网才能成功进行软件更新。</span><span>  如果您无法正常更新，也可以直接访问国内网站 <a href="https://noteey.cn/">https://noteey.cn/</a> 下载最新安装包，然后直接安装覆盖即可，无需卸载老版本！</span></div>', null, '立即更新', null, () => {
                                                checkUpdate();
                                            })
                                        }else {
                                            checkUpdate();
                                        }
                                    }} loading={isCheckingUpdate}>{updateProgress}</Button>
                        </div>

                        <div key={'autoUpdate'} className='flex-item item-margin'>
                            <div className='flex-grow-1 flex-col'>
                                <span className='font-size-18-w400'>{t("Auto update")}</span>
                                <span className='var-gray-7 mt-4'>{t("Close will not auto update")}</span>
                            </div>
                            <Switch value={isAutoUpdate} style={{width: '32px'}} onChange={onAutoUpdateChanged}/>
                        </div>

                        {
                            hasCommunity &&
                            <div key={'comunity'} className='item-margin flex-item'>
                                <div className='flex-grow-1 flex-col'>
                                    <span className='font-size-18-w400'>{t("Join com")}</span>
                                    {/*<span className='var-gray-7 font-size-12 mt-6'>{t("Get help or something")}</span>*/}
                                    <div className='mt-4' style={{display: 'flex', flexDirection: 'row'}}>
                                        <div className='com-item hovered'
                                             onClick={() => ipcSend("open-url", "https://twitter.com/muenzoapp")}>
                                            <img className='img-medium-small' src={imgPathPerfix() + "x.png"}/>
                                            <span className='font-size-10'>X</span>
                                        </div>
                                        <div className='com-item ml-8 hovered'
                                             onClick={() => ipcSend("open-url", "https://discord.gg/uWDus73pfy")}>
                                            <img className='img-medium-small' src={imgPathPerfix() + "discord.png"}/>
                                            <span className='font-size-10'>Discord</span>
                                        </div>
                                        <div className='com-item ml-8 hovered'
                                             onClick={() => ipcSend("open-url", "https://forum.muenzo.com/")}>
                                            <img className='img-medium-small' src={imgPathPerfix() + "forum.png"}/>
                                            <span className='font-size-10'>Forum</span>
                                        </div>
                                        <div className='com-item ml-8 hovered'
                                             onClick={() => ipcSend("open-url", "https://www.reddit.com/r/muenzo")}>
                                            <img className='img-medium-small' src={imgPathPerfix() + "reddit.png"}/>
                                            <span className='font-size-10'>Reddit</span>
                                        </div>
                                    </div>
                                </div>
                                {/*<Button className='button-solid-style' type="primary" onClick={()=>ipcSend("open-url",import.meta.env.VITE_HTTP_COMMUNITY)}>{t("Visit")}</Button>*/}
                            </div>
                        }

                        {
                            global.g_userInfo &&
                            isDevMode &&
                            //同步
                            <>
                        <span className='font-size-18-w500 item-margin bt-gray padding-bottom-6'
                              style={{marginTop: '26px'}}>{t("Sync")}</span>
                                <div className='mt-22 flex-item'>
                                    <div key={generateUUID2()} className='flex-grow-1 flex-row-vertical-center'>
                                        <div className='button-solid-style flex-center hovered font-family-medium'
                                             style={{minWidth: '102px', borderRadius: '16px'}} onClick={() => {
                                            if (isSyncing) {
                                                setIsSyncing(false);
                                                setSync(t("Sync"));
                                                refreshLastSyncTime();
                                                global.g_isSyncing = false;
                                                return;
                                            }
                                            if (!hasPublishLicense()) {
                                                postMessage(EVENT_SHOW_DESKTOP_PRO_VIP);
                                                return;
                                            }

                                            //同步
                                            global.g_isSyncing = true;
                                            setSyncInfo(t("Syncing"));
                                            setIsSyncing(true);
                                            setSync(t('Cancel sync'));
                                            syncS3((progress: any) => {
                                                if (isSyncing) {
                                                    setSyncInfo(t("Syncing") + Math.floor(progress * 100) + '%');
                                                }
                                            }).then(res => {
                                                if (DEBUG) {
                                                    console.log('sync finished...' + res);
                                                }
                                                setIsSyncing(false);
                                                setSync(t("Sync"));

                                                if ("success" == res) {
                                                    const szDate = formatDate(Date.now(), 'yyyy-MM-dd hh:mm:ss');
                                                    localStorage.setItem(KEY_LAST_SYNC_TIME, szDate);
                                                    refreshLastSyncTime();
                                                } else {
                                                    setSyncInfo(t("SyncFail"));
                                                }
                                            })
                                        }}>{sync}</div>
                                        <span className='var-gray-7 font-size-12 ml-20'>{syncInfo}</span>
                                    </div>
                                </div>
                                <div className={'bt-gray mt-22'}></div>
                            </>
                        }

                        {/*账户*/}
                        <span className='font-size-18-w500 item-margin bt-gray padding-bottom-6 font-family-medium'
                              style={{marginTop: '26px'}} onClick={() => {
                            if ((Date.now() - mFirstClickTime) > 3000) {
                                mClickTimes = 0;
                            }

                            //3s点击5次
                            if (mClickTimes === 0) {
                                mFirstClickTime = Date.now();
                            }
                            mClickTimes++;
                            if ((Date.now() - mFirstClickTime) <= 3000 && mClickTimes >= 5) {
                                const isFreeCardMode = localStorage.getItem(SYS_CONFIG_FREE_CARD_MODE);
                                if (isFreeCardMode == 'true') {
                                    message.info("关闭可以创建无限多卡片");
                                    localStorage.setItem(SYS_CONFIG_FREE_CARD_MODE, 'false');
                                } else {
                                    message.info("现在你可以创建无限多卡片了");
                                    localStorage.setItem(SYS_CONFIG_FREE_CARD_MODE, 'true');
                                }
                                mClickTimes = 0;
                            }
                        }}>{t("Account")}</span>
                        <div className='mt-8 flex-item'>
                            <div key={generateUUID2()} className='flex-grow-1 flex-col'>
                                <span className='font-size-18-w400'>{t("Your account")}</span>
                                <span className='var-gray-7 font-size-12 mt-4' style={{textWrap:'wrap'}}>{loginAccountDesc}</span>
                            </div>
                            {renderLoginStatus()}
                        </div>

                        <div key={'managerLicense'} className='item-margin flex-item'>
                            <div key={generateUUID2()} className='flex-grow-1 flex-col'>
                                <span className='font-size-18-w400'>{t("License")}</span>
                                {renderLicense()}
                            </div>
                            <div className='flex-center font-size-12 hovered setting-button-style font-family-medium' style={{
                                display: (!hasLicense()) ? 'none' : 'inherit',
                                minWidth: '126px', padding: '0px 1px 0px 1px'
                            }}
                                 onClick={() => ipcSend("open-url", import.meta.env.VITE_HTTP_ACCOUNT_MANAGER)}>{t("Manager license")}</div>
                        </div>

                        {/*<div className='item-margin flex-item'>*/}
                        {/*    <div className='flex-grow-1 flex-col'>*/}
                        {/*        <span className='large-text'>{t("Commercial license")}</span>*/}
                        {/*        <span className='var-gray-7 font-size-12 mt-6'>{t("If used commercial")}</span>*/}
                        {/*    </div>*/}
                        {/*    {renderCommercialLicense()}*/}
                        {/*</div>*/}
                        {/*<a href='#' className='link-color font-size-12 mt-6'>{t("Get more")}</a>*/}

                        {/*<div className='item-margin flex-item'>*/}
                        {/*    <div className='flex-grow-1 flex-col'>*/}
                        {/*        <span className='large-text'>{t("Publisher license")}</span>*/}
                        {/*        <span className='var-gray-7 font-size-12 mt-6'>{t("If used publisher")}</span>*/}
                        {/*    </div>*/}
                        {/*    {renderPublisherLicense()}*/}
                        {/*</div>*/}
                        {/*<a href='#' className='link-color font-size-12 mt-6'>{t("Get more")}</a>*/}

                        <span style={{marginTop: '22px'}}
                              className='font-size-18-w500 item-margin bt-gray padding-bottom-6 font-family-medium'>{t("Other")}</span>


                        <div className='mt-8 flex-item'>
                            <span className='font-size-18-w400 flex-grow-1'>{t("Language")}</span>
                            <Dropdown menu={{items: arrayLanguages, onClick: onLanguageClick}} trigger={['click']}>
                                <div className='flex-row-vertical-center hovered setting-button-style'
                                     style={{minWidth: '126px'}}>
                                    <span style={{flexGrow: '1'}}>{languageName}</span>
                                    <IconDropdown/>
                                </div>
                            </Dropdown>
                        </div>

                        <div className='item-margin flex-item'>
                            <span className='font-size-18-w400 flex-grow-1'>{t("Theme")}</span>
                            <Dropdown menu={{items: arrayDarkMenu(), onClick: onThemeClick}} trigger={['click']}>
                                <div className='flex-row-vertical-center hovered setting-button-style'
                                     style={{minWidth: '126px'}}>
                                    <span style={{flexGrow: '1'}}>{themeName}</span>
                                    <IconDropdown/>
                                </div>
                            </Dropdown>
                        </div>

                        <div className='item-margin flex-item'>
                            <span className='font-size-18-w400 flex-grow-1'>{t("Date format")}</span>
                            <Dropdown menu={{items: arrayDateformats, onClick: onDateformatClick}} trigger={['click']}>
                                <div className='flex-row-vertical-center hovered setting-button-style'
                                     style={{minWidth: '126px'}}>
                                    <span style={{flexGrow: '1'}}>{dateFormat}</span>
                                    <IconDropdown/>
                                </div>
                            </Dropdown>
                        </div>

                    </div>

                    {
                        //region *****home preference*******
                        currentMenu == 'homePreference' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px',
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("HomePreference")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("CustomizeTheButtons")}</span>

                            {
                                // arrayHomeLeftMenu.map(p=> {
                                //     return <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                //         <span style={{display: 'block', flexGrow: '1'}}>{t("HomeWhiteboard")}</span>
                                //         <Switch style={{width: '32px'}} onChange={(e) => {
                                //
                                //         }}/>
                                //     </div>
                                // })
                            }

                            <div className={'flex-row-vertical-center setting-home-preference-item'}
                                 style={{marginTop: '20px'}}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("HomeWhiteboard")}</span>
                                <Switch value={homeLeftMenu.home} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('home', e);
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Projects")}</span>
                                <Switch value={homeLeftMenu.projects} style={{width: '32px'}} onChange={(e) => {
                                    // onSwitchCustomize('projects',e);
                                    message.info(t("CantBeHidden"));
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Journal")}</span>
                                <Switch value={homeLeftMenu.journal} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('journal', e);
                                }}/>
                            </div>
                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Library")}</span>
                                <Switch value={homeLeftMenu.library} style={{width: '32px'}} onChange={(e) => {
                                    // onSwitchCustomize('library',e);
                                    message.info(t("CantBeHidden"));
                                }}/>
                            </div>
                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Tags")}</span>
                                <Switch value={homeLeftMenu.tags} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('tags', e);
                                }}/>
                            </div>
                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Highlights")}</span>
                                <Switch value={homeLeftMenu.highlights} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('highlights', e);
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Properties")}</span>
                                <Switch value={homeLeftMenu.properties} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('properties', e);
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("favor")}</span>
                                <Switch value={homeLeftMenu.favor} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('favor', e);
                                }}/>
                            </div>
                            <div className={'flex-row-vertical-center setting-home-preference-item'}>
                                <span style={{display: 'block', flexGrow: '1'}}>{t("Recents")}</span>
                                <Switch value={homeLeftMenu.recent} style={{width: '32px'}} onChange={(e) => {
                                    onSwitchCustomize('recent', e);
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center mt-16'} style={{justifyContent: 'flex-end'}}>
                                <label>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                        //全部显示
                                        setHomeLeftMenu(DEFAULT_HOME_LEFT_MENU);
                                        setAAtomHomeLeftMenu(DEFAULT_HOME_LEFT_MENU);
                                        localStorage.setItem(KEY_HOME_LEFT_MENU_CUSTOMIZE, JSON.stringify(DEFAULT_HOME_LEFT_MENU));
                                        // updateSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE,DEFAULT_HOME_LEFT_MENU);
                                        setIsShowSettingDialog(false);
                                    }}>{t("Reset to default")}</button>
                                </label>
                                <label className={'ml-16'}>
                                    <button className={'button-solid-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px'}} onClick={() => {
                                        setAAtomHomeLeftMenu(homeLeftMenu);
                                        localStorage.setItem(KEY_HOME_LEFT_MENU_CUSTOMIZE, JSON.stringify(homeLeftMenu));
                                        // updateSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE,homeLeftMenu);
                                        setIsShowSettingDialog(false);

                                        //判断当前页面，--不显示的话就转到默认的.
                                        let bNeedToHome = false;
                                        if (!homeLeftMenu.journal && isInJournal()){
                                            bNeedToHome = true;
                                        }else if (!homeLeftMenu.tags && isInPageTag()){
                                            bNeedToHome = true;
                                        }else if (!homeLeftMenu.highlights && isInPageHighlight()){
                                            bNeedToHome = true;
                                        }else if (!homeLeftMenu.properties && isInPageProperties()){
                                            bNeedToHome = true;
                                        }

                                        if (bNeedToHome){
                                            window.navPage('recent');
                                        }

                                    }}>{t("Save changes")}</button>
                                </label>
                            </div>

                        </div>
                        //endregion
                    }

                    {
                        //region 全局配置
                        currentMenu == "globalPreference" &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px',
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span
                                    className={'font-size-18-w500 font-family-medium'}>{t("Global Preferences")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("CustomizeTheGlobalDiaplay")}</span>

                            <div className='item-margin flex-item'>
                                <div className={'flex-col'}>
                                    <div>
                                        <span
                                            className='flex-grow-1'>{t("ElementTypeOnDoubleClick")}</span>
                                        <span className={'setting-pro ml-6'}>PRO</span>
                                    </div>

                                    <span
                                        style={{color: 'var(--text-color-7)',textWrap:'wrap'}}>{t("ElementTypeOnDoubleClickTip")}</span>
                                </div>

                                <Dropdown menu={{
                                    items: arrayDoubleClickMenu(), onClick: (item: any) => {
                                        // localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_DOUBLE_CLICK_ELEMENT = item.key;
                                        let visibleItem = arrayDoubleClickMenu().find(p => p.key == item.key);
                                        setDoubleClickElement(visibleItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px', marginLeft: 'auto'}} onMouseDown={(event) => {
                                        if (!hasLicense()) {
                                            event.preventDefault();
                                            window.showMessageBox(t("Upgrade required"), t("YouNeedToUpgradeToChooseElement"), t("Cancel"), t("Learn more"), null, () => {
                                                if (isZh()) {
                                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                                } else {
                                                    ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                                }
                                            })
                                        }
                                    }}>
                                        <span style={{flexGrow: '1'}}>{doubleClickElement}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>

                            <div className='item-margin flex-item'>
                                <span className='flex-grow-1 font-family-medium'>{t("Spell checker")}</span>
                                <Dropdown menu={{
                                    items: arrayOnOff(), onClick: (item: any) => {
                                        // localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_SPELLCHECKER = item.key;
                                        let visibleItem = arrayOnOff().find(p => p.key == item.key);
                                        setSpellChecker(visibleItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{spellChecker}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>

                            <div className='item-margin flex-item'>
                                <span className='flex-grow-1 font-family-medium'>{t("VisibilityOfInfoPanel")}</span>
                                <Dropdown menu={{
                                    items: arrayVisiblityMenu(), onClick: (item: any) => {
                                        // localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_INFO_VISIBLE = item.key;
                                        let visibleItem = arrayVisiblityMenu().find(p => p.key == item.key);
                                        setVisibleInfoPanel(visibleItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{visibleInfoPanel}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>
                            <div className='item-margin flex-item'>
                                <span className='font-family-medium flex-grow-1'>{t("VisibilityOfSnapLines")}</span>
                                <Dropdown menu={{
                                    items: arrayVisiblityMenu(), onClick: (item: any) => {
                                        // localStorage.setItem(KEY_GLOBAL_SNAP_LINE_VISIBLE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_SNAP_LINE_VISIBLE = item.key;
                                        let visibleItem = arrayVisiblityMenu().find(p => p.key == item.key);
                                        setVisibleSnapLine(visibleItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{visibleSnapLine}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>
                            <div className='item-margin flex-item'>
                                <span className='font-family-medium flex-grow-1'>{t("DefaultConnectorType")}</span>
                                <Dropdown menu={{
                                    items: arrayConnectorTypeMenu(), onClick: (item) => {
                                        // localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_CONNECTOR_TYPE = item.key;
                                        let connectItem = arrayConnectorTypeMenu().find(p => p.key == item.key);
                                        setConnectorType(connectItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{connectorType}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>
                            <div className='item-margin flex-item'>
                                <span className='font-family-medium flex-grow-1'>{t("DisplayModeOfCard")}</span>
                                <Dropdown menu={{
                                    items: arrayCardDisplayModeMenu(), onClick: (item) => {
                                        // localStorage.setItem(KEY_GLOBAL_CARD_DISPLAY_MODE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_CARD_DISPLAY_MODE = item.key;
                                        let cardDisplayItem = arrayCardDisplayModeMenu().find(p => p.key == item.key);
                                        setCardDisplayMode(cardDisplayItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{cardDisplayMode}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>

                            <div className='item-margin flex-item'>
                                <span className='flex-grow-1 font-family-medium'>{t("YoutubeEmbedMode")}</span>
                                <Dropdown menu={{
                                    items: arrayDefaultNoCookie(), onClick: (item: any) => {
                                        // localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE,item.key);
                                        mGlobalPreference.current.KEY_GLOBAL_YOUTUBE_EMBED_MODE = item.key;
                                        let visibleItem = arrayDefaultNoCookie().find(p => p.key == item.key);
                                        setYoutubeEmbedMode(visibleItem?.label);
                                    }
                                }} trigger={['click']}>
                                    <div className='flex-row-vertical-center hovered setting-button-style'
                                         style={{minWidth: '126px'}}>
                                        <span style={{flexGrow: '1'}}>{youtubeEmbedMode}</span>
                                        <IconDropdown/>
                                    </div>
                                </Dropdown>
                            </div>

                            <div className={'flex-row-vertical-center mt-22'} style={{justifyContent: 'flex-end'}}>
                                <label>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                        //恢复默认
                                        localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE, 'visible');
                                        localStorage.setItem(KEY_GLOBAL_SNAP_LINE_VISIBLE, 'visible');
                                        localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE, 'curve');
                                        localStorage.setItem(KEY_GLOBAL_CARD_DISPLAY_MODE, 'sidePanel');
                                        localStorage.setItem(KEY_GLOBAL_SPELLCHECKER, 'on');
                                        localStorage.setItem(KEY_GLOBAL_DOUBLE_CLICK_ELEMENT, 'card');
                                        localStorage.setItem(KEY_GLOBAL_YOUTUBE_EMBED_MODE,'default');

                                        mGlobalPreference.current.KEY_GLOBAL_INFO_VISIBLE = 'visible';
                                        mGlobalPreference.current.KEY_GLOBAL_SNAP_LINE_VISIBLE = 'visible';
                                        mGlobalPreference.current.KEY_GLOBAL_CONNECTOR_TYPE = 'curve';
                                        mGlobalPreference.current.KEY_GLOBAL_CARD_DISPLAY_MODE = 'sidePanel';
                                        mGlobalPreference.current.KEY_GLOBAL_SPELLCHECKER = 'on';
                                        mGlobalPreference.current.KEY_GLOBAL_DOUBLE_CLICK_ELEMENT = 'card';
                                        mGlobalPreference.current.KEY_GLOBAL_YOUTUBE_EMBED_MODE = 'default';

                                        setDoubleClickElement(t('Card'));
                                        setVisibleInfoPanel(t("Visible"));
                                        setVisibleSnapLine(t("Visible"));
                                        setConnectorType(t("Curve"));
                                        setCardDisplayMode(t("Side panel"))
                                        setSpellChecker(t("On"));
                                        setYoutubeEmbedMode(t('Default'));

                                    }}>{t("Reset to default")}</button>
                                </label>
                                <label className={'ml-16'}>
                                    <button className={'button-solid-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px'}} onClick={() => {
                                        localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE, mGlobalPreference.current.KEY_GLOBAL_INFO_VISIBLE);
                                        localStorage.setItem(KEY_GLOBAL_SNAP_LINE_VISIBLE, mGlobalPreference.current.KEY_GLOBAL_SNAP_LINE_VISIBLE);
                                        localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE, mGlobalPreference.current.KEY_GLOBAL_CONNECTOR_TYPE);
                                        localStorage.setItem(KEY_GLOBAL_CARD_DISPLAY_MODE, mGlobalPreference.current.KEY_GLOBAL_CARD_DISPLAY_MODE);
                                        localStorage.setItem(KEY_GLOBAL_SPELLCHECKER, mGlobalPreference.current.KEY_GLOBAL_SPELLCHECKER);
                                        localStorage.setItem(KEY_GLOBAL_DOUBLE_CLICK_ELEMENT, mGlobalPreference.current.KEY_GLOBAL_DOUBLE_CLICK_ELEMENT);
                                        localStorage.setItem(KEY_GLOBAL_YOUTUBE_EMBED_MODE,mGlobalPreference.current.KEY_GLOBAL_YOUTUBE_EMBED_MODE);
                                        setIsShowSettingDialog(false);
                                        postMessage(EVENT_SHOW_SNAP_LINE);
                                        ipcInvoke('update-spellcheck', {spellcheck: mGlobalPreference.current.KEY_GLOBAL_SPELLCHECKER})
                                    }}>{t("Save changes")}</button>
                                </label>
                            </div>
                        </div>
                        //endregion
                    }

                    {
                        //region *********备份部分...********/
                        currentMenu == 'backup' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px'
                        }}>
                            {/*本地路径*/}

                            {/*<div className={'item-margin flex-row-vertical-center'}>*/}
                            {/*    <span*/}
                            {/*        className='font-size-18-w500 font-family-medium'>{t("Storage location")}</span>*/}
                            {/*    <div className={'flex-center'} style={{*/}
                            {/*        marginLeft: '4px',*/}
                            {/*        height: '20px',*/}
                            {/*        minWidth: '40px',*/}
                            {/*        background: 'var(--beta-background-color)',*/}
                            {/*        borderRadius: '5px',*/}
                            {/*        color: 'var(--beta-text-color)'*/}
                            {/*    }}>Beta*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            {/*<div className={'flex-row-vertical-center mt-2'}>*/}
                            {/*    <span style={{color: 'var(--text-color-66666)'}}>{t("AllYourProjectsAndFiles")}</span>*/}
                            {/*</div>*/}
                            {/*<div className={'flex-row-vertical-center mt-10'}>*/}
                            {/*    <input className={'input-border'} readOnly={true} value={fileDir}*/}
                            {/*           style={{width: '428px', height: '32px'}}/>*/}
                            {/*    <div style={{flexGrow: '1'}}></div>*/}
                            {/*    <div className='flex-center font-size-12 hovered setting-button-style' style={{*/}
                            {/*        minWidth: '126px', padding: '0px 1px 0px 1px', height: '32px',*/}
                            {/*    }} onClick={() => {*/}
                            {/*        ipcInvoke('open-select-dir').then(async (res) => {*/}
                            {/*            if (res) {*/}
                            {/*                //这里取一下所有有用的文件....*/}
                            {/*                const arrayFiles = await getAllFilePaths()*/}

                            {/*                const sep = await ipcInvoke('get-file-sep')*/}
                            {/*                localStorage.setItem(KEY_FILE_DIR, res + sep);*/}
                            {/*                setFileDir(res + sep);*/}

                            {/*                ipcInvoke('setUserFileDir', {fileDir: res, arrayFiles: arrayFiles})*/}
                            {/*            }*/}
                            {/*        })*/}
                            {/*    }}>{t("Change")}</div>*/}
                            {/*</div>*/}

                            {/*备份*/}
                            {/*<span className='item-margin bt-gray padding-bottom-6 font-size-18-w500'>{t("Local backup")}</span>*/}
                            {/*<div style={{*/}
                            {/*    background: 'var(--line-color)',*/}
                            {/*    height: '1px',*/}
                            {/*    marginTop: '26px',*/}
                            {/*    marginBottom: '6px'*/}
                            {/*}}></div>*/}
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("Database backup")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("DatabaseBackupTips")}</span>

                            <div className={'flex-row-vertical-center item-margin'}>
                                {/*<div className={'flex-col'}>*/}
                                {/*    <div className={'item-margin flex-row-vertical-center'}>*/}
                                {/*        <span className='font-family-medium'>{t("EnableAutoBackup")}</span>*/}
                                {/*    </div>*/}
                                {/*    <span style={{color: 'var(--text-color-66666)'}}>{t("AutoBackupWhen")}</span>*/}
                                {/*</div>*/}
                                <span className='font-family-medium'>{t("EnableAutoBackup")}</span>

                                <div style={{flexGrow: '1'}}></div>

                                <Switch value={isEnableAutoBackup} style={{width: '32px'}} onChange={async (e: any) => {
                                    setIsEnableAutoBackup(e);
                                    localStorage.setItem(KEY_ENABLE_AUTO_BACKUP, e ? 'true' : 'false');
                                    if (e) {
                                        window.startAutoBackup();
                                    } else {
                                        window.stopAutoBackup();
                                    }
                                }}/>
                            </div>

                            {/*自动备份时间*/}
                            <div className={'flex-row-vertical-center item-margin'}>
                                <span className='font-family-medium'>{t("AutoBackupInterval")}</span>
                                <ConfigProvider
                                    theme={{
                                        components: {
                                            Select: {
                                                /* 这里是你的组件 token */
                                                /* 这里是你的全局 token --setting-button-border-color*/
                                                borderRadius:8,
                                                colorBorder:'var(--setting-button-border-color)',
                                                colorBgElevated:'var(--background-color-white)',
                                                colorPrimaryHover:'var(--setting-button-border-color)',
                                                colorPrimary:'var(--setting-button-border-color)',
                                                colorText:'var(--text-color)',
                                            },
                                        },
                                    }}
                                >
                                    <Select className={'ml-8 setting-select-style'} value={autoBackupInterval}
                                            disabled={!isEnableAutoBackup}
                                            dropdownClassName={'shadow'}
                                            suffixIcon={<img className={'img-10'}
                                                             src={getImagePathWithTheme('home_small_favor_dropdown')}/>}
                                            style={{minWidth: '126px',marginLeft:'auto',}} options={getArrayAutoBackupOptions()}
                                            onChange={(value, option) => {
                                                setAutoBackupInterval(value);
                                                localStorage.setItem(KEY_AUTO_BACKUP_INTERVAL, value);
                                            }}></Select>
                                </ConfigProvider>

                            </div>

                            {/*只备份数据库*/}
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-family-medium'}>{t("Back up location")}</span>
                                <img className={'img-12 ml-10 cursor-pointer'} src={imgPathPerfix() + 'link_icon.png'}
                                     onClick={() => {
                                         ipcSend('open-item-in-folder',  autoBackupPath)
                                     }}/>
                            </div>
                            <div className={'flex-row-vertical-center mt-10'}>
                                <input className={'input-border input-setting-background'} readOnly={true} value={autoBackupPath}
                                       style={{width: '428px', height: '32px'}}/>
                                <div style={{flexGrow: '1'}}></div>
                                <div className='flex-center font-size-12 hovered setting-button-style' style={{
                                    minWidth: '126px', padding: '0px 1px 0px 1px', height: '32px',
                                }} onClick={() => {
                                    ipcInvoke('open-select-dir').then(async(res) => {
                                        if (res) {
                                            const sep = await ipcInvoke('get-file-sep')
                                            localStorage.setItem(KEY_AUTO_BACKUP_PATH, res+sep);
                                            setAutoBackupPath(res+sep);
                                        }
                                    })
                                }}>{t("Change")}</div>
                            </div>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <label>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={async () => {

                                                /*
                                                const fileName = autoBackupPath+'Noteey_AutoBackup'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.db'
                                        ipcInvoke('save-file',{filters:[{ name: 'db', extensions: ['db'] }],fileName:fileName}).then(async (res) => {
                                            if (res) {
                                                //手动的备份
                                                if (isBackuping) return;//正在备份，不接受再次点击...
                                                mIsShowBackupSuccess = false;

                                                //备份
                                                setIsBackuping(true);
                                                const blobDb = await exportDb((progress: any) => {
                                                    const fProgress = (progress.completedRows / progress.totalRows) / 2;
                                                    // console.log('export progress,'+fProgress)
                                                    setBackupProgress(fProgress);//占 50%
                                                });

                                                var reader = new FileReader();
                                                reader.onload = function (result) {
                                                    ipcInvoke('backup', {
                                                        filePath:autoBackupPath,
                                                        fileName: fileName,
                                                        stream: result.target.result,
                                                        arrayFiles: []
                                                    })
                                                }
                                                reader.readAsArrayBuffer(blobDb);
                                            }
                                        }) */
                                        if (window.saveNotes){
                                            await window.saveNotes();
                                        }

                                        //直接备份到目的文件夹.
                                        //手动的备份
                                        mBackupMode = 'onlyDb';
                                        if (isAutoBackuping) return;//正在备份，不接受再次点击...
                                        mIsShowBackupSuccess = false;
                                        setBackupProgress(0);

                                        //备份
                                        setIsAutoBackuping(true);
                                        const blobDb = await exportDb((progress: any) => {
                                            const fProgress = (progress.completedRows / progress.totalRows);
                                            // console.log('export progress,'+fProgress)
                                            setBackupProgress(fProgress);//占 50%
                                        });
                                        const fileName = autoBackupPath+'Noteey_AutoBackup'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.db'
                                        var reader = new FileReader();
                                        reader.onload = function (result) {
                                            ipcInvoke('backup', {
                                                filePath:autoBackupPath,
                                                fileName: fileName,
                                                stream: result.target.result,
                                                arrayFiles: []
                                            })
                                        }
                                        reader.readAsArrayBuffer(blobDb);

                                    }}>{t("Backup")}</button>
                                </label>
                                <label className={'ml-16'}>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                                //自动备份的
                                                restore( {name:'Db',extensions:['db']},autoBackupPath);
                                    }}>{t("Restore")}</button>
                                </label>

                                <div style={{flexGrow: '1'}}></div>

                                {
                                    isAutoBackuping &&
                                    <>
                                        <Spin indicator={<LoadingOutlined spin/>}/>
                                        <span className={'ml-8'}>{(100 * backupProgress).toFixed(2) + '%'}</span>
                                    </>
                                }

                                {
                                    //导出完成
                                    isShowAutoBackupFinishedView &&
                                    <>
                                        <img className={'img-14'} src={getImagePathWithTheme('check_black')}/>
                                        <span style={{color: 'var(--primary-color)'}}
                                              className={'hovered-font-blue ml-6'}
                                              onClick={() => {
                                                  ipcSend('open-item-in-folder', mszAutoBackupPath??autoBackupPath)
                                              }}>{t("View")}</span>
                                    </>
                                }

                            </div>

                            {/***************分隔线全局full备份 全局备份******************/}
                            <div className={'line'} style={{margin: '22px 0 0 0', width: '100%'}}></div>

                            <div className={'flex-row-vertical-center mt-18'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("Full backup")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("IncludesAllData")}</span>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-family-medium'}>{t("Back up location")}</span>
                                <img className={'img-12 ml-10 cursor-pointer'} src={imgPathPerfix() + 'link_icon.png'}
                                     onClick={() => {
                                         ipcSend('open-item-in-folder', mszBackupPath ? mszBackupPath : backupPath)
                                     }}/>
                            </div>
                            <div className={'flex-row-vertical-center mt-10'}>
                                <input className={'input-border input-setting-background'} readOnly={true} value={backupPath}
                                       style={{width: '428px', height: '32px'}}/>
                                <div style={{flexGrow: '1'}}></div>
                                <div className='flex-center font-size-12 hovered setting-button-style' style={{
                                    minWidth: '126px', padding: '0px 1px 0px 1px', height: '32px',
                                }} onClick={() => {
                                    ipcInvoke('open-select-dir').then(async(res) => {
                                        if (res) {
                                            const sep = await ipcInvoke('get-file-sep')
                                            localStorage.setItem(KEY_BACKUP_PATH, res+sep);
                                            setBackupPath(res+sep);
                                        }
                                    })
                                }}>{t("Change")}</div>
                            </div>


                            {/******************这里是备份**************************/}
                            {/******************这里是备份**************************/}
                            {/******************这里是备份**************************/}
                            {/******************这里是备份**************************/}
                            {/******************这里是备份**************************/}
                            <div className={'flex-row-vertical-center mt-16'}>
                                <div className='flex-center font-size-12 hovered setting-button-style' style={{
                                    minWidth: '136px', padding: '0px 1px 0px 1px', height: '32px',
                                }} onClick={async () => {
                                    mBackupMode = 'full';
                                    if (isBackuping) return;//正在备份，不接受再次点击...
                                    mIsShowBackupSuccess = false;

                                    if (window.saveNotes){
                                        await window.saveNotes();
                                    }

                                    //备份
                                    setIsBackuping(true);
                                    const blobDb = await exportDb((progress: any) => {
                                        const fProgress = (progress.completedRows / progress.totalRows) / 2;
                                        // console.log('export progress,'+fProgress)
                                        setBackupProgress(fProgress);//占 50%
                                    });

                                    //要备份的全部路径
                                    const arrayFiles = await getAllFilePaths();

                                    var reader = new FileReader();
                                    reader.onload = function (result) {
                                        ipcInvoke('backup', {
                                            filePath: backupPath,
                                            stream: result.target.result,
                                            arrayFiles: arrayFiles
                                        })
                                    }
                                    reader.readAsArrayBuffer(blobDb);

                                }}>{t("Backup")}</div>

                                {/*//全局恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复恢复*/}
                                <label className={'ml-16'}>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                        restore({name:'Zip',extensions:['zip']},backupPath);
                                    }}>{t("Restore")}</button>
                                </label>

                                <div style={{flexGrow: '1'}}></div>

                                {
                                    isBackuping &&
                                    <>
                                        <Spin indicator={<LoadingOutlined spin/>}/>
                                        <span className={'ml-8'}>{(100 * backupProgress).toFixed(2) + '%'}</span>
                                    </>
                                }

                                {
                                    //导出完成
                                    isShowBackupFinishedView &&
                                    <>
                                        <img className={'img-14'} src={getImagePathWithTheme('check_black')}/>
                                        <span style={{color: 'var(--primary-color)'}}
                                              className={'hovered-font-blue ml-6'}
                                              onClick={() => {
                                                  ipcSend('open-item-in-folder', mszBackupPath)
                                              }}>{t("View")}</span>
                                    </>
                                }


                            </div>

                            {/*<span className={'font-family-medium mt-22'}>{t("Restore from backups")}</span>*/}
                            {/*<div className={'line mt-8'}></div>*/}
                            {/*<span className={'mt-16'}*/}
                            {/*      style={{color: 'var(--text-gray)'}}>{t("UploadTheFileAllData")}</span>*/}
                            {/*<div className={'mt-4'} style={{color: 'var(--text-gray)'}}*/}
                            {/*     dangerouslySetInnerHTML={{__html: t('WarningUpload')}}></div>*/}

                            {/*//恢复*/}
                            {/*<div className={'flex-row-vertical-center'}>*/}
                            {/*<span className='flex-center font-size-12 hovered setting-button-style mt-16' style={{*/}
                            {/*    padding: '0px 1px 0px 1px', height: '32px', minWidth: '136px',*/}
                            {/*}} onClick={() => {*/}
                            {/*    if (isRestoring) return;*/}
                            {/*    ipcInvoke('restore');*/}
                            {/*}}>{t("Upload zip file")}</span>*/}
                            {/*    <div style={{flexGrow: '1'}}></div>*/}
                            {/*    {*/}
                            {/*        isRestoring &&*/}
                            {/*        <>*/}
                            {/*            <Spin indicator={<LoadingOutlined spin/>}/>*/}
                            {/*            <span className={'ml-8'}>{(100 * restoreProgress).toFixed(2) + '%'}</span>*/}
                            {/*        </>*/}
                            {/*    }*/}
                            {/*</div>*/}
                        </div>
                        //endregion
                    }

                    {
                        //region sync部分
                        currentMenu == 'sync' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px'
                        }}>
                            <div className={'flex-row-vertical-center'}>
                                <div className={'flex-col'}>
                                    <div className={'item-margin flex-row-vertical-center'}>
                                        <span className='font-size-18-w500 font-family-medium'>{t("Enable sync")}</span>
                                        <span className={'beta flex-center'}>Beta</span>
                                    </div>
                                    <span style={{color: 'var(--text-color-66666)'}}>{t("SyncYourDataViaClound")}</span>
                                </div>

                                <div style={{flexGrow: '1'}}></div>

                                <Switch value={isEnableSync} style={{width: '32px'}} onChange={async (e: any) => {
                                    setIsEnableSync(e);
                                    const szEnabled = e ? 'true' : 'false';
                                    localStorage.setItem(KEY_IS_ENABLE_SYNC, szEnabled);
                                    ipcSend('is-enable-cloud-sync', {isEnabledSync: isAutoEnableSync()});
                                    if (!e) {
                                        //还原路径为默认的
                                        //这里取一下所有有用的文件....
                                        const arrayFiles = await getAllFilePaths()
                                        localStorage.setItem(KEY_FILE_DIR, global.g_defaultStorePath);
                                        setFileDir(global.g_defaultStorePath);
                                        //清除自动记忆关闭窗口弹窗
                                        localStorage.setItem(KEY_AUTO_SAVE_CLOUD_DB,'false');

                                        ipcInvoke('setUserFileDir', {fileDir: global.g_defaultStorePath, arrayFiles: arrayFiles,isCopy:true}).then(res=>{
                                            // ipcSend('is-enable-cloud-sync',{isEnabledSync:isAutoEnableSync()})
                                        })
                                    }
                                    window.refreshSyncMenu();
                                }}/>
                            </div>

                            {
                                isEnableSync &&
                                <>
                                    <div className={'item-margin flex-row-vertical-center'}>
                                        <span className='font-size-18-w500 font-family-medium'>{t("Sync location")}</span>
                                        <Tooltip arrow={false} open={false} title={t("")}>
                                            <img className={'img-16 ml-4 cursor-pointer'}
                                                 src={getImagePathWithTheme('file_mode_help')} onClick={()=>{
                                                if (isZh()) {
                                                    ipcSend('open-url',import.meta.env.VITE_HTTP_SYNC_DRIVER_ZH)
                                                }else {
                                                    ipcSend('open-url', import.meta.env.VITE_HTTP_SYNC_DRIVER);
                                                }
                                            }}/>
                                        </Tooltip>
                                    </div>

                                    <div className={'flex-row-vertical-center mt-2'}>
                                        <span style={{color: 'var(--text-color-66666)'}}>{t("PleaseChange")}</span>
                                    </div>
                                    <div className={'flex-row-vertical-center mt-10'}>
                                        <input className={'input-border'} readOnly={true}
                                               value={fileDir == global.g_defaultStorePath ? '' : fileDir}
                                               placeholder={t('SelectDefaultPath')}
                                               style={{width: '428px', height: '32px',background:'var(--box-shadow-border)!important'}}/>
                                        <div style={{flexGrow: '1'}}></div>
                                        <div className='flex-center font-size-12 hovered setting-button-style' style={{
                                            minWidth: '126px', padding: '0px 1px 0px 1px', height: '32px',
                                        }} onClick={() => {
                                            ipcInvoke('open-select-dir').then(async (res) => {
                                                if (res) {
                                                    //这里取一下所有有用的文件....
                                                    const arrayFiles = await getAllFilePaths()

                                                    const sep = await ipcInvoke('get-file-sep')
                                                    localStorage.setItem(KEY_FILE_DIR, res + sep);
                                                    setFileDir(res + sep);

                                                    ipcInvoke('setUserFileDir', {fileDir: res, arrayFiles: arrayFiles}).then(res=>{
                                                        ipcSend('is-enable-cloud-sync',{isEnabledSync:isAutoEnableSync()})
                                                    })
                                                }
                                            })
                                        }}>{t("Change")}</div>
                                    </div>

                                    {
                                        // false &&
                                        <>
                                            <div className={'line mt-26'}></div>
                                            <div className={'flex-row-vertical-center mt-26'}>
                                        <span
                                            className={'font-size-18-w500 font-family-semi-bold'}>{t("CloudSyncPreferences")}</span>
                                            </div>
                                            {/*<span style={{color: 'var(--text-gray)'}}>{t("CustomizeTheButtons")}</span>*/}

                                            <div className={'flex-row-vertical-center setting-home-preference-item'}
                                                 style={{marginTop: '16px'}}>
                                            <span style={{
                                                display: 'block',
                                                flexGrow: '1'
                                            }}>{t("AutoRefreshWhenOpening")}</span>
                                                <Switch value={cloudSyncPreferences.autoRefreshWhenOpenApp} style={{width: '32px'}} onChange={(e) => {
                                                    const newValue = {...cloudSyncPreferences};
                                                    newValue.autoRefreshWhenOpenApp = e;
                                                    newValue.autoSyncWhenCloseApp = e;
                                                    setCloudSyncPreferences(newValue);
                                                    localStorage.setItem(KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP,e?'true':'false');
                                                    localStorage.setItem(KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP,e?'true':'false');

                                                    // message.destroy();
                                                    // message.info(<div className={'flex-col'} style={{textAlign:'left'}}>
                                                    //     <span>{t("CloudToast1")}</span>
                                                    //     <span>{t("CloudToast2")}</span>
                                                    //     <span>{t("CloudToast3")}</span>
                                                    //     <span>{t("CloudToast4")}</span>
                                                    // </div>,5)
                                                    dialogOtherTipRef.current?.onShowDialog();
                                                }}/>
                                            </div>

                                            <div className={'flex-row-vertical-center setting-home-preference-item'}
                                                 style={{marginTop: '10px'}}>
                                                <span style={{
                                                    display: 'block',
                                                    flexGrow: '1'
                                                }}>{t("AutoSyncWhenExitingTheApp")}</span>
                                                <Switch value={cloudSyncPreferences.autoSyncWhenCloseApp} style={{width: '32px'}} onChange={(e) => {
                                                    const newValue = {...cloudSyncPreferences};
                                                    newValue.autoRefreshWhenOpenApp = e;
                                                    newValue.autoSyncWhenCloseApp = e;
                                                    setCloudSyncPreferences(newValue);
                                                    localStorage.setItem(KEY_GLOBAL_SYNC_AUTO_REFRESH_WHEN_OPEN_APP,e?'true':'false');
                                                    localStorage.setItem(KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP,e?'true':'false');

                                                    // message.destroy();
                                                    // message.info(<div className={'flex-col'} style={{textAlign:'left'}}>
                                                    //     <span>{t("CloudToast1")}</span>
                                                    //     <span>{t("CloudToast2")}</span>
                                                    //     <span>{t("CloudToast3")}</span>
                                                    //     <span>{t("CloudToast4")}</span>
                                                    // </div>,5)
                                                    dialogOtherTipRef.current?.onShowDialog();
                                                }}/>
                                            </div>
                                        </>
                                    }
                                </>
                            }
                        </div>
                        //endregion
                    }

                    {
                        //region import file部分
                        currentMenu == 'importFile' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px'
                        }}>
                            {/*本地路径*/}
                            <div className={'item-margin flex-row-vertical-center'}>
                            <span
                                className='font-size-18-w500 font-family-medium'>{t("Import file")}</span>
                            </div>

                            <div className={'line mt-10'}></div>
                            <span className={'mt-10'}
                                  style={{color: 'var(--color-666666)'}}>{t("CustomizeYourFile")}</span>

                            <Checkbox className={'import-file-checkbox-item font-size-12'} checked={importFileMode == 'askMe'}
                                      onChange={(e) => {
                                          setImportFileMode('askMe');
                                          localStorage.setItem(KEY_FILE_IMPORT_MODE, 'askMe');//文件导入的类型..askMe/importMode/linkMode
                                      }}>{t("Asked each time")}</Checkbox>
                            <div className={'flex-row-vertical-center import-file-checkbox-item'}>
                                <Checkbox className={'default-font-family default-font-color font-size-12'}
                                          checked={importFileMode == 'importMode'} onChange={(e) => {
                                    setImportFileMode('importMode');
                                    localStorage.setItem(KEY_FILE_IMPORT_MODE, 'importMode');//文件导入的类型..askMe/importMode/linkMode
                                }}>{t("AlwaysCopyMode")}</Checkbox>
                                <Tooltip arrow={false} title={t("CopyTheFileToYourLibrary")}>
                                    <img className={'img-14 ml-2 cursor-pointer'} src={getImagePath('file_mode_help')}/>
                                </Tooltip>
                            </div>

                            <div className={'flex-row-vertical-center import-file-checkbox-item'}>
                                <Checkbox className={'default-font-family default-font-color font-size-12'}
                                          checked={importFileMode == 'linkMode'} onChange={(e) => {
                                    setImportFileMode('linkMode');
                                    localStorage.setItem(KEY_FILE_IMPORT_MODE, 'linkMode');//文件导入的类型..askMe/importMode/linkMode
                                }}>{t("Always link mode")}</Checkbox>
                                <Tooltip arrow={false} title={t("AccessOriginalFileWithout")}>
                                    <img className={'img-14 ml-2 cursor-pointer'} src={getImagePath('file_mode_help')}/>
                                </Tooltip>
                            </div>
                            {
                                false &&
                                <>
                                    <Checkbox className={'import-file-checkbox-item'}
                                              checked={importFileMode == 'advanced'} onChange={(e) => {
                                        setImportFileMode('advanced');
                                        localStorage.setItem(KEY_FILE_IMPORT_MODE, 'advanced');//文件导入的类型..askMe/importMode/linkMode/advanced
                                    }}>{t("Advanced")}</Checkbox>
                                    {
                                        isAdvancedChecked &&
                                        <div style={{paddingLeft: '16px'}}>
                                            <div className={'flex-row-vertical-center mt-16'}>
                                                <div className={'flex-col'}>
                                                    <span
                                                        className={'font-family-medium'}>{t("IfFileSmallerThen")}</span>
                                                    <span style={{height: '0', opacity: '0'}}
                                                          className={'font-family-medium'}>{t("IfFileLargerThen")}</span>
                                                </div>
                                                <input className={'input-border ml-8 flex-center'}
                                                       style={{width: '80px', textAlign: 'center'}} onChange={(e) => {
                                                    if (isNumber(e.target.value)) {
                                                        setFileSizeSplit(e.target.value);
                                                        localStorage.setItem(KEY_FILE_SIZE_SPLIT, e.target.value)
                                                    }
                                                }}
                                                       placeholder={fileSizeSplitPlaceholder} value={fileSizeSplit}/>
                                                <span className={'ml-8'}>MB,</span>
                                                <Select className={'ml-8'} value={fileSizeSmallerThenMode}
                                                        suffixIcon={<img className={'img-10'}
                                                                         src={getImagePathWithTheme('home_small_favor_dropdown')}/>}
                                                        style={{minWidth: '136px'}} options={arrayFileSmallerThen}
                                                        onChange={(value, option) => {
                                                            setFileSizeSmallerThenMode(value);
                                                            localStorage.setItem(KEY_FILE_SIZE_SMALLER_THEN_MODE, value);
                                                        }}></Select>
                                            </div>

                                            <div className={'flex-row-vertical-center mt-16'}>
                                                <div className={'flex-col'}>
                                                    <span style={{height: '0', opacity: '0'}}
                                                          className={'font-family-medium'}>{t("IfFileSmallerThen")}</span>
                                                    <span
                                                        className={'font-family-medium'}>{t("IfFileLargerThen")}</span>
                                                </div>

                                                <input className={'input-border ml-8 flex-center'}
                                                       style={{width: '80px', textAlign: 'center'}} onChange={(e) => {
                                                    if (isNumber(e.target.value)) {
                                                        setFileSizeSplit(e.target.value);
                                                        localStorage.setItem(KEY_FILE_SIZE_SPLIT, e.target.value)
                                                    }
                                                }}
                                                       placeholder={fileSizeSplitPlaceholder} value={fileSizeSplit}/>
                                                <span className={'ml-8'}>MB,</span>
                                                <Select className={'ml-8'} value={fileSizeLargerThenMode}
                                                        suffixIcon={<img className={'img-10'}
                                                                         src={getImagePathWithTheme('home_small_favor_dropdown')}/>}
                                                        style={{minWidth: '136px'}} options={arrayFileSmallerThen}
                                                        onChange={(value, option) => {
                                                            setFileSizeLargerThenMode(value);
                                                            localStorage.setItem(KEY_FILE_SIZE_LARGER_THEN_MODE, value);
                                                        }}></Select>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>

                        //endregion
                    }

                    {
                        //region Shortcuts Setting 快捷键----

                        currentMenu == 'shortcutsSetting' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                            padding: '0px 36px',
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("Shortcuts Setting")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("CustomizeKeyboardShortcut")}</span>

                            <div className={'flex-row-vertical-center mt-20'}>
                                <span>{t("QuickNotes")}</span>
                                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                    <div className={'flex-row-vertical-center ' + (shortcutsConfig[0].isPressed ? 'setting-shortcuts-item-pressed' : (shortcutsConfig[0].shortcuts?'setting-shortcuts-item':'setting-shortcuts-item-blank'))}>
                                        <span style={{color:shortcutsConfig[0].isPressed?'white':(shortcutsConfig[0].shortcuts?'var(--text-color)':'var(--shortcuts-blank-text-color)')}}>{shortcutsConfig[0].isPressed ? t('Press shortcut') : (shortcutsConfig[0].shortcuts || t("Blank"))}</span>
                                        {
                                            (shortcutsConfig[0].shortcuts || shortcutsConfig[0].isPressed) &&
                                            <img className={'img-18 ml-8 cursor-pointer'}
                                                 src={getImagePathWithThemeSvg('set_clear_shortcut')} onClick={(e) => {
                                                clearShortcuts(0);
                                                ipcInvoke('un-shortcuts');
                                            }}/>
                                        }
                                    </div>

                                    <img className={'img-16 ml-12 cursor-pointer'}
                                         src={getImagePathWithTheme('shortcut_edit.svg')} onClick={(event) => {
                                        const newConfig = [...shortcutsConfig];
                                        resetShortcutConfigPressed(newConfig);
                                        newConfig[0].isPressed = true;
                                        setShortcutsConfig(newConfig);
                                    }}/>
                                </div>
                            </div>
                            <div className={'line mt-12'}></div>

                            <div className={'flex-row-vertical-center mt-16'}>
                                <span>{t("NewCardInApp")}</span>
                                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                    <div
                                        className={'flex-row-vertical-center ' + (shortcutsConfig[1].isPressed ? 'setting-shortcuts-item-pressed' : (shortcutsConfig[1].shortcuts?'setting-shortcuts-item':'setting-shortcuts-item-blank'))}>
                                        <span style={{color:shortcutsConfig[1].isPressed?'white':(shortcutsConfig[1].shortcuts?'var(--text-color)':'var(--shortcuts-blank-text-color)')}}>{shortcutsConfig[1].isPressed ? t('Press shortcut') : shortcutsConfig[1].shortcuts || t('Blank')}</span>
                                        {
                                            (shortcutsConfig[1].shortcuts || shortcutsConfig[1].isPressed) &&
                                            <img className={'img-18 ml-8 cursor-pointer'}
                                                 src={getImagePathWithThemeSvg('set_clear_shortcut')} onClick={(e) => {
                                                clearShortcuts(1);
                                            }}/>
                                        }
                                    </div>

                                    <img className={'img-16 ml-12 cursor-pointer'}
                                         src={getImagePathWithTheme('shortcut_edit.svg')} onClick={(event) => {
                                        const newConfig = [...shortcutsConfig];
                                        resetShortcutConfigPressed(newConfig);
                                        newConfig[1].isPressed = true;
                                        setShortcutsConfig(newConfig);
                                    }}/>
                                </div>
                            </div>
                            <div className={'line mt-12'}></div>

                            <div className={'flex-row-vertical-center mt-16'}>
                                <span>{t("GlobalSearch")}</span>
                                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                                    <div
                                        className={'flex-row-vertical-center ' + (shortcutsConfig[2].isPressed ? 'setting-shortcuts-item-pressed' : (shortcutsConfig[2].shortcuts?'setting-shortcuts-item':'setting-shortcuts-item-blank'))}>
                                        <span style={{color:shortcutsConfig[2].isPressed?'white':(shortcutsConfig[2].shortcuts?'var(--text-color)':'var(--shortcuts-blank-text-color)')}}>{shortcutsConfig[2].isPressed ? t('Press shortcut') : (shortcutsConfig[2].shortcuts || t('Blank'))}</span>
                                        {
                                            (shortcutsConfig[2].shortcuts || shortcutsConfig[2].isPressed) &&
                                            <img className={'img-18 ml-8 cursor-pointer'}
                                                 src={getImagePathWithThemeSvg('set_clear_shortcut')} onClick={(e) => {
                                                clearShortcuts(2);
                                            }}/>
                                        }
                                    </div>

                                    <img className={'img-16 ml-12 cursor-pointer'}
                                         src={getImagePathWithTheme('shortcut_edit.svg')} onClick={(event) => {
                                        const newConfig = [...shortcutsConfig];
                                        resetShortcutConfigPressed(newConfig);
                                        newConfig[2].isPressed = true;
                                        setShortcutsConfig(newConfig);
                                    }}/>
                                </div>
                            </div>
                            <div className={'mt-12'} style={{borderBottom:'1px solid var(--line-color)'}}></div>
                        </div>

                        //endregion
                    }

                    {
                        //region webviewer
                        currentMenu == 'webview' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            width: '100%',
                            padding: '0px 36px'
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("Web viewer")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("ManageYouWebViewer")}</span>

                            <div className={'item-margin flex-col'} style={{}}>
                                {/*<div className='item-margin flex-item'>*/}
                                {/*    <span className='flex-grow-1'>{t("DefaultAppForOpeningWebPage")}</span>*/}
                                {/*    <Dropdown menu={{*/}
                                {/*        items: arrayDefaultWebviewerOpen(), onClick: (item: any) => {*/}
                                {/*            const newWebConfig:any = {...webviewerConfig};*/}
                                {/*            newWebConfig.defaultOpen = item.key;*/}
                                {/*            setWebviewerConfig(newWebConfig);*/}
                                {/*        }*/}
                                {/*    }} trigger={['click']}>*/}
                                {/*        <div className='flex-row-vertical-center hovered setting-button-style'*/}
                                {/*             style={{minWidth: '126px'}}>*/}
                                {/*            <span style={{flexGrow: '1'}}>{arrayDefaultWebviewerOpen().find(p=>p.key == webviewerConfig?.defaultOpen)?.label}</span>*/}
                                {/*            <IconDropdown/>*/}
                                {/*        </div>*/}
                                {/*    </Dropdown>*/}
                                {/*</div>*/}

                                <div className='item-margin flex-item' style={{marginTop:'0px'}}>
                                    <span className='flex-grow-1 '>{t("DefaultSearch")}</span>
                                    <Dropdown menu={{
                                        items: arrayDefaultSearchEngine(), onClick: (item: any) => {
                                            // localStorage.setItem(KEY_GLOBAL_INFO_VISIBLE,item.key);
                                            const newWebConfig:any = {...webviewerConfig};
                                            newWebConfig.defaultSearch = item.key;
                                            setWebviewerConfig(newWebConfig);
                                        }
                                    }} trigger={['click']}>
                                        <div className='flex-row-vertical-center hovered setting-button-style'
                                             style={{minWidth: '126px'}}>
                                            <span style={{flexGrow: '1'}}>{arrayDefaultSearchEngine().find(p=>p.key == webviewerConfig?.defaultSearch)?.label}</span>
                                            <IconDropdown/>
                                        </div>
                                    </Dropdown>
                                </div>

                                {/*<div className={'flex-row-vertical-center item-margin'}>*/}
                                {/*    <span className=''>{t("ShowBookmarkBar")}</span>*/}

                                {/*    <div style={{flexGrow: '1'}}></div>*/}

                                {/*    <Switch value={isEnableAutoBackup} style={{width: '32px'}}*/}
                                {/*            onChange={async (e: any) => {*/}
                                {/*                setIsEnableAutoBackup(e);*/}
                                {/*                localStorage.setItem(KEY_ENABLE_AUTO_BACKUP, e ? 'true' : 'false');*/}

                                {/*            }}/>*/}
                                {/*</div>*/}

                                <span className='font-family-regular mt-22'>{t("Home URL")}</span>
                                <input className={'input-border mt-12'} placeholder={'http://'} value={webviewerConfig?.defaultUrl} onInput={(e)=>{
                                    const newWebConfig = {...webviewerConfig};
                                    newWebConfig.defaultUrl = e.currentTarget.value;
                                    setWebviewerConfig(newWebConfig);
                                }}/>
                            </div>

                            <div className={'flex-row-vertical-center mt-22'} style={{justifyContent: 'flex-end'}}>
                                <label>
                                    <button className={'button-border-gray-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                        //恢复默认
                                        //直接删了配置
                                        localStorage.removeItem(KEY_WEBVIEWER_CONFIG);
                                        setWebviewerConfig(GET_DEFAULT_WEBVIEWER_CONFIG());
                                    }}>{t("Reset to default")}</button>
                                </label>
                                <label className={'ml-16'}>
                                    <button className={'button-solid-style flex-center'}
                                            style={{padding: '0 16px', minWidth: '136px'}} onClick={() => {
                                        localStorage.setItem(KEY_WEBVIEWER_CONFIG,JSON.stringify(webviewerConfig));
                                        setIsShowSettingDialog(false);
                                    }}>{t("Save changes")}</button>
                                </label>
                            </div>

                        </div>
                        //endregion
                    }

                    {
                        //region quick note
                        currentMenu == 'quickNote' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            width: '100%',
                            padding: '0px 36px'
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <span className={'font-size-18-w500 font-family-medium'}>{t("QuickNoteSettings")}</span>
                            </div>
                            <span style={{color: 'var(--text-color-7)'}}>{t("SetTheDefaultActionWhenSave")}</span>

                            <div className={'item-margin flex-col'} style={{}}>

                                <div className='item-margin flex-item' style={{marginTop: '0px'}}>
                                    <div className={'flex-col cursor-pointer'} style={{width:'100%'}} onClick={(e)=>{
                                        //配置默认tag
                                        window.showManageTags([],(arrayNewTags,itemRemoved)=>{
                                            const quickNotesConfig = {...quickNoteDefaultConfig};
                                            const arrayTags:any = [];
                                            for (let i=0;i<arrayNewTags.length;i++){
                                                arrayTags.push(arrayNewTags[i].name);
                                            }
                                            quickNotesConfig.defaultTags = arrayTags;
                                            setQuickNoteDefaultConfig(quickNotesConfig);
                                            localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(quickNotesConfig));
                                        });
                                    }}>
                                        <span className='flex-grow-1'>{t("Default tag")}</span>
                                        <div className={'flex-row-vertical-center mt-6'}>
                                            <div className={'flex-row-vertical-center input-border'} style={{flexGrow:'1'}}>
                                                <span className={''}>{getDefaultTags()}</span>
                                                <img className={'img-16'} style={{marginLeft: 'auto'}}
                                                     src={getImagePathWithThemeSvg('small_right_arrow')}/>
                                            </div>
                                            {
                                                quickNoteDefaultConfig.defaultTags &&
                                                <img className={'img-18 ml-16'}
                                                     style={{position:'absolute',right:'0px'}}
                                                     src={getImagePathWithThemeSvg('set_remove_quicknotes_config')}
                                                     onClick={(e) => {
                                                         e.stopPropagation();
                                                         const quickNotesConfig = {...quickNoteDefaultConfig};
                                                         delete quickNotesConfig.defaultTags;
                                                         setQuickNoteDefaultConfig(quickNotesConfig);
                                                         localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(quickNotesConfig));
                                                     }}/>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='item-margin flex-item' style={{marginTop: '16px'}}>
                                    <div className={'flex-col cursor-pointer'} style={{width: '100%'}} onClick={(e) => {
                                        window.showDialogChooseProject([],'',FROM_LINK_TO_PROJECT,(project)=>{
                                            const quickNotesConfig = {...quickNoteDefaultConfig};
                                            quickNotesConfig.defaultProject = project;
                                            setQuickNoteDefaultConfig(quickNotesConfig);
                                            getDefaultProjectName(quickNotesConfig.defaultProject.id);
                                            localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(quickNotesConfig));
                                        })
                                    }}>
                                        <span className='flex-grow-1'>{t("Default project")}</span>
                                        <div className={'flex-row-vertical-center mt-6'}>
                                            <div className={'flex-row-vertical-center input-border'} style={{flexGrow:'1'}}>
                                            <span
                                                className={''}>{defaultQuickNoteProjectName}</span>
                                                <img className={'img-16'} style={{marginLeft: 'auto'}}
                                                     src={getImagePathWithThemeSvg('small_right_arrow')}/>
                                                {
                                                    quickNoteDefaultConfig.defaultProject &&
                                                    <img className={'img-18 ml-16'}
                                                         style={{position:'absolute',right:'0px'}}
                                                         src={getImagePathWithThemeSvg('set_remove_quicknotes_config')} onClick={(e)=>{
                                                             e.stopPropagation();
                                                        const quickNotesConfig = {...quickNoteDefaultConfig};
                                                        delete quickNotesConfig.defaultProject;
                                                        setQuickNoteDefaultConfig(quickNotesConfig);
                                                        getDefaultProjectName(null);
                                                        localStorage.setItem(KEY_QUICKNOTE_CONFIG,JSON.stringify(quickNotesConfig));
                                                    }}/>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        //endregion
                    }

                    {
                        //region about
                        currentMenu == 'about' &&
                        <div className={'container'} style={{
                            position: 'absolute',
                            left: '0',
                            top: '0',
                            height: '100%',
                            padding: '0px 36px'
                        }}>
                            <div className={'flex-row-vertical-center mt-16'}>
                                <img style={{width: '60px', height: '60px'}}
                                     src={imgPathPerfix() + 'setting_about_logo.png'}/>
                                <div className={'flex-col ml-20'}>
                                    <span className={'font-size-16 font-family-semi-bold'}>{t("AppName")}</span>
                                    <span
                                        style={{color: 'var(--color-666666)'}}>{t("Version") + " " + currentVersion.replace("V", "")}</span>
                                </div>
                            </div>

                            <div className={'flex-col mt-26'}>
                                <span className={'font-size-14 font-family-medium'}>{t("Legal")}</span>
                                <span className={'setting-legal-item mt-10'} onClick={() => {
                                    navUrl(import.meta.env.VITE_HTTP_TERM_OF_SERVICE, import.meta.env.VITE_HTTP_TERM_OF_SERVICE_ZH);
                                }}>{t("TermsOfService")}</span>
                                <span className={'setting-legal-item'} onClick={() => {
                                    navUrl(import.meta.env.VITE_HTTP_PRIVACY_POLICY, import.meta.env.VITE_HTTP_PRIVACY_POLICY_ZH);
                                }}>{t("PrivacyPolicy")}</span>
                                <span className={'setting-legal-item'} onClick={() => {
                                    navUrl(import.meta.env.VITE_HTTP_LICENSE_NOTICE, import.meta.env.VITE_HTTP_LICENSE_NOTICE_ZH);
                                }}>{t("LicenseNotices")}</span>
                            </div>

                            <div className={'flex-col mt-22'}>
                                <span className={'font-size-14 font-family-medium'}>{t("Community")}</span>
                                <span style={{color: 'var(--color-666666)'}}
                                      className={'mt-4'}>{t("JoinOurDiscord")}</span>
                                <label>
                                    <button className={'button-border-gray-style flex-center mt-16 font-family-medium'}
                                            style={{padding: '0 16px',border:'1px solid var(--setting-button-border-color)'}} onClick={() => {
                                        navUrl(import.meta.env.VITE_HTTP_COMMUNITY);
                                    }}>{t("JoinDiscordCommunity")}</button>
                                </label>

                            </div>

                        </div>

                        //endregion
                    }

                </div>


                <Modal destroyOnClose={true} closeIcon={<IconClose/>} zIndex={9999} centered={true}
                       onCancel={() => setIsLoginDialogShow(false)} open={isLoginDialogShow} footer={''}>
                    <LoginIndex onCloseDialogEvent={onCloseLoginDialog}/>
                </Modal>

                <DialogMessageBox ref={dialogMessageBoxRef}/>

                <DialogUpdate ref={dialogUpdateRef} onStartUpdateEvent={() => {
                    setIsCheckingUpdate(true);
                    setUpdateProgress(t('Start download'));
                    ipcSend('start-download-update')
                }} onSkipUpdate={() => {
                    setIsCheckingUpdate(false);
                }}/>

                <DialogLicenseHelper ref={dialogLicenseHelperRef}/>

                <DialogOtherTip ref={dialogOtherTipRef}/>

                {/*<img className='img-mini-small-10 cursor-pointer' style={{position:'absolute',right:'16px',top:'16px'}}*/}
                {/*     src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")} onClick={()=>{*/}
                {/*         setIsShowSettingDialog(false);*/}
                {/*}}/>*/}

                {
                    isRestoring &&
                    <div style={{width:'calc(100% + 48px)',height:'calc(100% + 52px)',left:'-0px',top:'-0px',position:'absolute',background:'#00000099',display:'flex',alignItems:'center',justifyContent:'center',margin:'-20px -24px'}}>
                        <Spin indicator={IconIndicatorWhite}/>
                        <span className={'ml-8'} style={{color:'white'}}>{(100 * restoreProgress).toFixed(2) + '%'}</span>
                    </div>
                }
            </div>
        </Modal>
    )
})

export default SettingIndex;